const listingStore = {
  namespaced: true,
  state: {
    properties: [
      {
        id: "68EBayState",
        title: "68 E Bay State St #3F, Alhambra, CA 91801",
        price: "868000",
        soldDate: "",
        soldPrice: "",
        bedroom: "3",
        bathroom: "3",
        livingArea: "2010",
        lotSize: "26149",
        lotSizeAcre: "",
        yearBuild: "",
        thumb: true,
        pics: [
          "MLS_1.jpg",
          "MLS_2.jpg",
          "MLS_3.jpg",
          "MLS_4.jpg",
          "MLS_5.jpg",
          "MLS_6.jpg",
          "MLS_7.jpg",
          "MLS_8.jpg",
          "MLS_9.jpg",
          "MLS_10.jpg",
          "MLS_11.jpg",
          "MLS_12.jpg",
          "MLS_13.jpg",
          "MLS_14.jpg",
          "MLS_15.jpg",
          "MLS_16.jpg",
          "MLS_17.jpg",
          "MLS_18.jpg",
          "MLS_19.jpg",
          "MLS_20.jpg",
          "MLS_21.jpg",
          "MLS_22.jpg",
          "MLS_23.jpg",
          "MLS_24.jpg",
          "MLS_25.jpg",
          "MLS_26.jpg",
          "MLS_27.jpg",
          "MLS_28.jpg",
          "MLS_29.jpg",
          "MLS_30.jpg",
          "MLS_31.jpg",
          "MLS_32.jpg",
          "MLS_33.jpg",
          "MLS_34.jpg",
          "MLS_35.jpg",
          "MLS_36.jpg",
          "MLS_37.jpg",
          "MLS_38.jpg",
          "MLS_39.jpg",
          "MLS_40.jpg",
          "MLS_41.jpg",
          "MLS_42.jpg",
          "MLS_43.jpg",
          "MLS_44.jpg",
          "MLS_45.jpg",
          "MLS_46.jpg",
          "MLS_47.jpg",
          "MLS_48.jpg",
          "MLS_49.jpg",
          "MLS_50.jpg",
          "MLS_51.jpg",
          "MLS_52.jpg",
          "MLS_53.jpg",
          "MLS_54.jpg",
          "MLS_55.jpg",
          "MLS_56.jpg",
          "MLS_57.jpg",
          "MLS_58.jpg",
          "MLS_59.jpg",
          "MLS_60.jpg",
          "MLS_61.jpg",
        ],
      },
      {
        id: "8723Pine",
        title: "8723 1/2 Pine Crest Pl, Rancho Cucamonga, CA 91730",
        price: "498000",
        soldDate: "",
        soldPrice: "",
        bedroom: "3",
        bathroom: "2.5",
        livingArea: "1304",
        lotSize: "4000",
        lotSizeAcre: "",
        yearBuild: "1983",
        thumb: true,
        pics: [
          "MLS_1.jpg", "MLS_2.jpg", "MLS_3.jpg", "MLS_4.jpg", "MLS_5.jpg", "MLS_6.jpg", "MLS_7.jpg", "MLS_8.jpg", "MLS_9.jpg", "MLS_10.jpg",
          "MLS_11.jpg", "MLS_12.jpg", "MLS_13.jpg", "MLS_14.jpg", "MLS_15.jpg",
          "MLS_16.jpg", "MLS_17.jpg", "MLS_18.jpg", "MLS_19.jpg", "MLS_20.jpg",
          "MLS_21.jpg", "MLS_22.jpg", "MLS_23.jpg", "MLS_24.jpg", "MLS_25.jpg",
          "MLS_26.jpg", "MLS_27.jpg", "MLS_28.jpg", "MLS_29.jpg", "MLS_30.jpg",
          "MLS_31.jpg", "MLS_32.jpg", "MLS_33.jpg", "MLS_34.jpg", "MLS_35.jpg",
          "MLS_36.jpg", "MLS_37.jpg", "MLS_38.jpg", "MLS_39.jpg", "MLS_40.jpg",
          "MLS_41.jpg", "MLS_42.jpg", "MLS_43.jpg", "MLS_44.jpg", "MLS_45.jpg",
          "MLS_46.jpg", "MLS_47.jpg", "MLS_48.jpg"
        ],
        preview: [
          "MLS_1.jpg", "MLS_2.jpg", "MLS_3.jpg", "MLS_5.jpg", "MLS_7.jpg", "MLS_8.jpg", "MLS_12.jpg", "MLS_14.jpg", "MLS_15.jpg",
          "MLS_19.jpg", "MLS_24.jpg", "MLS_36.jpg", "MLS_37.jpg", "MLS_41.jpg", "MLS_43.jpg"
        ]
      },
      {
        id: "87ECommonwealth",
        title: "87 E. Commonwealth Ave, Alhambra, CA 91801",
        price: "798000",
        soldDate: "",
        soldPrice: "",
        bedroom: "2",
        bathroom: "2.5",
        livingArea: "1650",
        lotSize: "",
        lotSizeAcre: "",
        yearBuild: "2006",
        thumb: true,
        pics: [
          "MLS_1.jpg", "MLS_2.jpg", "MLS_3.jpg", "MLS_4.jpg", "MLS_5.jpg", "MLS_6.jpg", "MLS_7.jpg", "MLS_8.jpg", "MLS_9.jpg", "MLS_10.jpg",
          "MLS_11.jpg", "MLS_12.jpg", "MLS_13.jpg", "MLS_14.jpg", "MLS_15.jpg",
          "MLS_16.jpg", "MLS_17.jpg", "MLS_18.jpg", "MLS_19.jpg", "MLS_20.jpg",
          "MLS_21.jpg", "MLS_22.jpg", "MLS_23.jpg", "MLS_24.jpg", "MLS_25.jpg",
          "MLS_26.jpg", "MLS_27.jpg", "MLS_28.jpg", "MLS_29.jpg", "MLS_30.jpg",
          "MLS_31.jpg", "MLS_32.jpg", "MLS_33.jpg", "MLS_34.jpg", "MLS_35.jpg",
          "MLS_36.jpg", "MLS_37.jpg", "MLS_38.jpg", "MLS_39.jpg", "MLS_40.jpg",
          "MLS_41.jpg", "MLS_42.jpg", "MLS_43.jpg", "MLS_44.jpg", "MLS_45.jpg",
          "MLS_46.jpg", "MLS_47.jpg", "MLS_48.jpg", "MLS_49.jpg", "MLS_50.jpg",
          "MLS_51.jpg", "MLS_52.jpg", "MLS_53.jpg", "MLS_54.jpg", "MLS_55.jpg",
          "MLS_56.jpg", "MLS_57.jpg"
        ]
      },
      {
        id: "321NOrange",
        title: "321 N Orange Ave # 103, Monterey Park, CA 91755",
        price: "548000",
        soldDate: "",
        soldPrice: "",
        bedroom: "2",
        bathroom: "2",
        livingArea: "989",
        lotSize: "",
        lotSizeAcre: "",
        yearBuild: "1994",
        thumb: true,
        pics: [
          "MLS_1.jpg", "MLS_2.jpg", "MLS_3.jpg", "MLS_4.jpg", "MLS_5.jpg", "MLS_6.jpg", "MLS_7.jpg", "MLS_8.jpg", "MLS_9.jpg", "MLS_10.jpg",
          "MLS_11.jpg", "MLS_12.jpg", "MLS_13.jpg", "MLS_14.jpg", "MLS_15.jpg",
          "MLS_16.jpg", "MLS_17.jpg", "MLS_18.jpg", "MLS_19.jpg", "MLS_20.jpg",
          "MLS_21.jpg", "MLS_22.jpg", "MLS_23.jpg", "MLS_24.jpg", "MLS_25.jpg",
          "MLS_26.jpg", "MLS_27.jpg", "MLS_28.jpg", "MLS_29.jpg", "MLS_30.jpg",
          "MLS_31.jpg", "MLS_32.jpg", "MLS_33.jpg", "MLS_34.jpg", "MLS_35.jpg",
          "MLS_36.jpg", "MLS_37.jpg", "MLS_38.jpg", "MLS_39.jpg", "MLS_40.jpg",
          "MLS_41.jpg", "MLS_42.jpg", "MLS_43.jpg", "MLS_44.jpg"
        ]
      },
      //  {
      //         id:"2670SanAngelo",
      //         title:"2670 San Angelo Dr, Claremont, CA",
      //         price:"1698000",
      //         sold:true,
      //         soldDate:"",
      //         soldPrice:"",
      //         bedroom:"4",
      //         bathroom:"3",
      //         livingArea:"3237",
      //         lotSize:"20848",
      //         lotSizeAcre:"",
      //         yearBuild:"",
      //         thumb:true,
      //         preview:["MLS_4.jpg", "MLS_8.jpg","MLS_9.jpg", "MLS_11.jpg","MLS_13.jpg","MLS_14.jpg","MLS_16.jpg","MLS_19.jpg","MLS_20.jpg","MLS_21.jpg","MLS_26.jpg","MLS_28.jpg", "MLS_30.jpg","MLS_33.jpg","MLS_34.jpg","MLS_36.jpg","MLS_37.jpg","MLS_41.jpg","MLS_48.jpg","MLS_57.jpg","MLS_60.jpg", "MLS_63.jpg"],
      //         pics:[
      //         "MLS_1.jpg", "MLS_2.jpg", "MLS_3.jpg", "MLS_4.jpg", "MLS_5.jpg", "MLS_6.jpg", "MLS_7.jpg", "MLS_8.jpg", "MLS_9.jpg", "MLS_10.jpg",
      //         "MLS_11.jpg", "MLS_12.jpg", "MLS_13.jpg", "MLS_14.jpg", "MLS_15.jpg","MLS_16.jpg", "MLS_17.jpg", "MLS_18.jpg", "MLS_19.jpg", "MLS_20.jpg",
      //         "MLS_21.jpg", "MLS_22.jpg", "MLS_23.jpg", "MLS_24.jpg", "MLS_25.jpg","MLS_26.jpg", "MLS_27.jpg", "MLS_28.jpg", "MLS_29.jpg", "MLS_30.jpg",
      //         "MLS_31.jpg", "MLS_32.jpg", "MLS_33.jpg", "MLS_34.jpg", "MLS_35.jpg","MLS_36.jpg", "MLS_37.jpg", "MLS_38.jpg", "MLS_39.jpg", "MLS_40.jpg",
      //         "MLS_41.jpg", "MLS_42.jpg", "MLS_43.jpg", "MLS_44.jpg", "MLS_45.jpg",
      //         "MLS_46.jpg", "MLS_47.jpg", "MLS_48.jpg", "MLS_49.jpg", "MLS_50.jpg",
      //         "MLS_51.jpg", "MLS_52.jpg", "MLS_53.jpg", "MLS_54.jpg", "MLS_55.jpg",
      //         "MLS_56.jpg", "MLS_57.jpg", "MLS_58.jpg", "MLS_59.jpg", "MLS_60.jpg",
      //         "MLS_61.jpg", "MLS_62.jpg", "MLS_63.jpg", "MLS_64.jpg", "MLS_65.jpg",
      //         "MLS_66.jpg", "MLS_67.jpg", "MLS_68.jpg", "MLS_69.jpg", "MLS_70.jpg",
      //         "MLS_71.jpg", "MLS_72.jpg", "MLS_73.jpg", "MLS_74.jpg", "MLS_75.jpg",
      //         "MLS_76.jpg", "MLS_77.jpg", "MLS_78.jpg", "MLS_79.jpg", "MLS_80.jpg",
      //         "MLS_81.jpg", "MLS_82.jpg", "MLS_83.jpg", "MLS_84.jpg", "MLS_85.jpg",
      //         "MLS_86.jpg", "MLS_87.jpg", "MLS_88.jpg", "MLS_89.jpg", "MLS_90.jpg",
      //         "MLS_91.jpg", "MLS_92.jpg", "MLS_93.jpg", "MLS_94.jpg", "MLS_95.jpg",
      //         "MLS_96.jpg", "MLS_97.jpg", "MLS_98.jpg", "MLS_99.jpg"
      //         ]
      //         },
      {
        id: "212NStoneman",
        title: "212 N Stoneman Ave Apt E",
        price: "768000",
        sold: true,
        soldDate: "2025-11-20",
        soldPrice: "770000",
        bedroom: "3",
        bathroom: "2.5",
        livingArea: "1505",
        lotSize: "41954",
        lotSizeAcre: "",
        yearBuild: "",
        thumb: true,
        pics: ["MLS_1.jpg", "MLS_2.jpg", "MLS_3.jpg", "MLS_4.jpg", "MLS_5.jpg", "MLS_6.jpg", "MLS_7.jpg", "MLS_8.jpg", "MLS_9.jpg", "MLS_10.jpg", "MLS_11.jpg", "MLS_12.jpg", "MLS_13.jpg", "MLS_14.jpg", "MLS_15.jpg", "MLS_16.jpg", "MLS_17.jpg", "MLS_18.jpg", "MLS_19.jpg", "MLS_20.jpg", "MLS_21.jpg", "MLS_22.jpg", "MLS_23.jpg", "MLS_24.jpg", "MLS_25.jpg", "MLS_26.jpg", "MLS_27.jpg", "MLS_28.jpg", "MLS_29.jpg", "MLS_30.jpg", "MLS_31.jpg", "MLS_32.jpg", "MLS_33.jpg"],
      },
      { id: "1900Pepper", title: "1900 Pepper St Apt 12", price: "698000", sold: true, soldDate: "2025-11-14", soldPrice: "735000", bedroom: "3", bathroom: "2.5", livingArea: "1377", lotSize: "", lotSizeAcre: "", yearBuild: "", thumb: true, pics: ["MLS_1.jpg", "MLS_2.jpg", "MLS_3.jpg", "MLS_4.jpg", "MLS_5.jpg", "MLS_6.jpg", "MLS_7.jpg", "MLS_8.jpg", "MLS_9.jpg", "MLS_10.jpg", "MLS_11.jpg", "MLS_12.jpg", "MLS_13.jpg", "MLS_14.jpg", "MLS_15.jpg", "MLS_16.jpg", "MLS_17.jpg", "MLS_18.jpg", "MLS_19.jpg", "MLS_20.jpg", "MLS_21.jpg", "MLS_22.jpg", "MLS_23.jpg", "MLS_24.jpg", "MLS_25.jpg", "MLS_26.jpg", "MLS_27.jpg", "MLS_28.jpg", "MLS_29.jpg", "MLS_30.jpg", "MLS_31.jpg", "MLS_32.jpg", "MLS_33.jpg", "MLS_34.jpg", "MLS_35.jpg", "MLS_36.jpg", "MLS_37.jpg"] },
      {
        id: "925NStoneman",
        title: "925 N Stoneman Ave Unit A",
        price: "888000",
        sold: true,
        soldDate: "2025-11-07",
        soldPrice: "920000",
        bedroom: "3",
        bathroom: "2.5",
        livingArea: "1635",
        lotSize: "22086",
        lotSizeAcre: "",
        yearBuild: "",
        thumb: true,
        preview: ["MLS_1.jpg", "MLS_2.jpg", "MLS_3.jpg", "MLS_4.jpg", "MLS_5.jpg", "MLS_6.jpg", "MLS_7.jpg", "MLS_8.jpg", "MLS_9.jpg", "MLS_24.jpg", "MLS_25.jpg", "MLS_30.jpg"],
        pics: ["MLS_1.jpg", "MLS_2.jpg", "MLS_3.jpg", "MLS_4.jpg", "MLS_5.jpg", "MLS_6.jpg", "MLS_7.jpg", "MLS_8.jpg", "MLS_9.jpg", "MLS_10.jpg", "MLS_11.jpg", "MLS_12.jpg", "MLS_13.jpg", "MLS_14.jpg", "MLS_15.jpg", "MLS_16.jpg", "MLS_17.jpg", "MLS_18.jpg", "MLS_19.jpg", "MLS_20.jpg", "MLS_21.jpg", "MLS_22.jpg", "MLS_23.jpg", "MLS_24.jpg", "MLS_25.jpg", "MLS_26.jpg", "MLS_27.jpg", "MLS_28.jpg", "MLS_29.jpg", "MLS_30.jpg", "MLS_31.jpg", "MLS_32.jpg", "MLS_33.jpg", "MLS_34.jpg", "MLS_35.jpg", "MLS_36.jpg", "MLS_37.jpg"],
      },
      {
        id: "129NVega",
        title: "129 N Vega St, Alhambra, CA",
        price: "1380000",
        sold: true,
        soldDate: "2025-09-12",
        soldPrice: "1350000",
        bedroom: "4",
        bathroom: "4",
        livingArea: "2011",
        lotSize: "8238",
        lotSizeAcre: "",
        yearBuild: "",
        thumb: true,
        preview: ["MLS_1.jpg", "MLS_5.jpg", "MLS_6.jpg", "MLS_8.jpg", "MLS_11.jpg", "MLS_46.jpg"],
        pics: [
          "MLS_1.jpg",
          "MLS_2.jpg",
          "MLS_3.jpg",
          "MLS_4.jpg",
          "MLS_5.jpg",
          "MLS_6.jpg",
          "MLS_7.jpg",
          "MLS_8.jpg",
          "MLS_9.jpg",
          "MLS_10.jpg",
          "MLS_11.jpg",
          "MLS_12.jpg",
          "MLS_13.jpg",
          "MLS_14.jpg",
          "MLS_15.jpg",
          "MLS_16.jpg",
          "MLS_17.jpg",
          "MLS_18.jpg",
          "MLS_19.jpg",
          "MLS_20.jpg",
          "MLS_21.jpg",
          "MLS_22.jpg",
          "MLS_23.jpg",
          "MLS_24.jpg",
          "MLS_25.jpg",
          "MLS_26.jpg",
          "MLS_27.jpg",
          "MLS_28.jpg",
          "MLS_29.jpg",
          "MLS_30.jpg",
          "MLS_31.jpg",
          "MLS_32.jpg",
          "MLS_33.jpg",
          "MLS_34.jpg",
          "MLS_35.jpg",
          "MLS_36.jpg",
          "MLS_37.jpg",
          "MLS_38.jpg",
          "MLS_39.jpg",
          "MLS_40.jpg",
          "MLS_41.jpg",
          "MLS_42.jpg",
          "MLS_43.jpg",
          "MLS_44.jpg",
          "MLS_45.jpg",
          "MLS_46.jpg",
          "MLS_47.jpg",
          "MLS_48.jpg",
          "MLS_49.jpg",
          "MLS_50.jpg",
          "MLS_51.jpg",
          "MLS_52.jpg",
          "MLS_53.jpg",
          "MLS_54.jpg",
          "MLS_55.jpg",
          "MLS_56.jpg",
          "MLS_57.jpg",
          "MLS_58.jpg",
          "MLS_59.jpg",
        ],
      },
      {
        id: "2689ECalifornia",
        title: "2689 E California Blvd, San Marino, CA",
        price: "2398000",
        sold: true,
        soldDate: "2025-09-09",
        soldPrice: "2568000",
        bedroom: "4",
        bathroom: "4",
        livingArea: "2614",
        lotSize: "15025",
        lotSizeAcre: "",
        yearBuild: "",
        thumb: true,
        preview: ["MLS_3.jpg", "MLS_7.jpg", "MLS_13.jpg", "MLS_19.jpg", "MLS_36.jpg", "MLS_41.jpg", "MLS_52.jpg"],
        pics: [
          "MLS_1.jpg",
          "MLS_2.jpg",
          "MLS_3.jpg",
          "MLS_4.jpg",
          "MLS_5.jpg",
          "MLS_6.jpg",
          "MLS_7.jpg",
          "MLS_8.jpg",
          "MLS_9.jpg",
          "MLS_10.jpg",
          "MLS_11.jpg",
          "MLS_12.jpg",
          "MLS_13.jpg",
          "MLS_14.jpg",
          "MLS_15.jpg",
          "MLS_16.jpg",
          "MLS_17.jpg",
          "MLS_18.jpg",
          "MLS_19.jpg",
          "MLS_20.jpg",
          "MLS_21.jpg",
          "MLS_22.jpg",
          "MLS_23.jpg",
          "MLS_24.jpg",
          "MLS_25.jpg",
          "MLS_26.jpg",
          "MLS_27.jpg",
          "MLS_28.jpg",
          "MLS_29.jpg",
          "MLS_30.jpg",
          "MLS_31.jpg",
          "MLS_32.jpg",
          "MLS_33.jpg",
          "MLS_34.jpg",
          "MLS_35.jpg",
          "MLS_36.jpg",
          "MLS_37.jpg",
          "MLS_38.jpg",
          "MLS_39.jpg",
          "MLS_40.jpg",
          "MLS_41.jpg",
          "MLS_42.jpg",
          "MLS_43.jpg",
          "MLS_44.jpg",
          "MLS_45.jpg",
          "MLS_46.jpg",
          "MLS_47.jpg",
          "MLS_48.jpg",
          "MLS_49.jpg",
          "MLS_50.jpg",
          "MLS_51.jpg",
          "MLS_52.jpg",
          "MLS_53.jpg",
          "MLS_54.jpg",
          "MLS_55.jpg",
          "MLS_56.jpg",
          "MLS_57.jpg",
          "MLS_58.jpg",
          "MLS_59.jpg",
          "MLS_60.jpg",
          "MLS_61.jpg",
          "MLS_62.jpg",
        ],
      },
      {
        id: "2106Cedar",
        title: "2106 Cedar St Unit G, Alhambra, CA",
        price: "718000",
        sold: true,
        soldDate: "22025-09-11",
        soldPrice: "738888",
        bedroom: "3",
        bathroom: "2.5",
        livingArea: "1397",
        lotSize: "20002",
        lotSizeAcre: "",
        yearBuild: "",
        thumb: true,
        pics: ["MLS_1.jpg", "MLS_2.jpg", "MLS_3.jpg", "MLS_4.jpg", "MLS_5.jpg", "MLS_6.jpg", "MLS_7.jpg", "MLS_8.jpg", "MLS_9.jpg", "MLS_10.jpg", "MLS_11.jpg", "MLS_12.jpg", "MLS_13.jpg", "MLS_14.jpg", "MLS_15.jpg", "MLS_16.jpg", "MLS_17.jpg", "MLS_18.jpg", "MLS_19.jpg", "MLS_20.jpg", "MLS_21.jpg", "MLS_22.jpg", "MLS_23.jpg", "MLS_24.jpg", "MLS_25.jpg", "MLS_26.jpg", "MLS_27.jpg", "MLS_28.jpg", "MLS_29.jpg", "MLS_30.jpg", "MLS_31.jpg", "MLS_32.jpg", "MLS_33.jpg", "MLS_34.jpg", "MLS_35.jpg", "MLS_36.jpg", "MLS_37.jpg", "MLS_38.jpg", "MLS_39.jpg", "MLS_40.jpg", "MLS_41.jpg"],
      },
      {
        id: "620thevillage312",
        title: "620 The Village #312",
        price: "785000",
        sold: true,
        soldDate: "2025-08-01",
        soldPrice: "800000",
        bedroom: "1",
        bathroom: "1",
        livingArea: "619",
        lotSize: "",
        yearBuild: "",
        thumb: true,
        pics: [
          "MLS_1.jpg",
          "MLS_2.jpg",
          "MLS_3.jpg",
          "MLS_4.jpg",
          "MLS_5.jpg",
          "MLS_6.jpg",
          "MLS_7.jpg",
          "MLS_8.jpg",
          "MLS_9.jpg",
          "MLS_10.jpg",
          "MLS_11.jpg",
          "MLS_12.jpg",
          "MLS_13.jpg",
          "MLS_14.jpg",
          "MLS_15.jpg",
          "MLS_16.jpg",
          "MLS_17.jpg",
          "MLS_18.jpg",
          "MLS_19.jpg",
          "MLS_20.jpg",
          "MLS_21.jpg",
          "MLS_22.jpg",
          "MLS_23.jpg",
          "MLS_24.jpg",
          "MLS_25.jpg",
          "MLS_26.jpg",
          "MLS_27.jpg",
          "MLS_28.jpg",
          "MLS_29.jpg",
          "MLS_30.jpg",
          "MLS_31.jpg",
          "MLS_32.jpg",
          "MLS_33.jpg",
          "MLS_34.jpg",
          "MLS_35.jpg",
          "MLS_36.jpg",
          "MLS_37.jpg",
          "MLS_38.jpg",
          "MLS_39.jpg",
          "MLS_40.jpg",
          "MLS_41.jpg",
          "MLS_42.jpg",
          "MLS_43.jpg",
          "MLS_44.jpg",
          "MLS_45.jpg",
          "MLS_46.jpg",
          "MLS_47.jpg",
          "MLS_48.jpg",
          "MLS_49.jpg",
          "MLS_50.jpg",
          "MLS_51.jpg",
          "MLS_52.jpg",
          "MLS_53.jpg",
          "MLS_54.jpg",
          "MLS_55.jpg",
          "MLS_56.jpg",
          "MLS_57.jpg",
          "MLS_58.jpg",
          "MLS_59.jpg",
          "MLS_60.jpg",
          "MLS_61.jpg",
          "MLS_62.jpg",
          "MLS_63.jpg",
          "MLS_64.jpg",
          "MLS_65.jpg",
          "MLS_66.jpg",
        ],
      },
      {
        id: "1696ShadyBrook",
        title: "1696 Shady Brook Dr #114, Fullerton, CA 92831",
        price: "799000",
        sold: true,
        soldDate: "2025-08-19",
        soldPrice: "830000",
        bedroom: "3",
        bathroom: "3",
        livingArea: "1360",
        lotSize: "",
        lotSizeAcre: "596",
        yearBuild: "",
        thumb: true,
        pics: ["MLS_1.jpg", "MLS_2.jpg", "MLS_3.jpg", "MLS_4.jpg", "MLS_5.jpg", "MLS_6.jpg", "MLS_7.jpg", "MLS_8.jpg", "MLS_9.jpg", "MLS_10.jpg", "MLS_11.jpg", "MLS_12.jpg", "MLS_13.jpg", "MLS_14.jpg", "MLS_15.jpg", "MLS_16.jpg", "MLS_17.jpg", "MLS_18.jpg", "MLS_19.jpg", "MLS_20.jpg", "MLS_21.jpg", "MLS_22.jpg", "MLS_23.jpg", "MLS_24.jpg", "MLS_25.jpg", "MLS_26.jpg", "MLS_27.jpg", "MLS_28.jpg", "MLS_29.jpg", "MLS_30.jpg", "MLS_31.jpg", "MLS_32.jpg", "MLS_33.jpg", "MLS_34.jpg", "MLS_35.jpg", "MLS_36.jpg", "MLS_37.jpg", "MLS_38.jpg", "MLS_39.jpg", "MLS_40.jpg", "MLS_41.jpg", "MLS_42.jpg", "MLS_43.jpg", "MLS_44.jpg", "MLS_45.jpg", "MLS_46.jpg"],
      },
      {
        id: "432NBushnell",
        title: "432 N Bushnell Ave, Alhambra, CA",
        price: "948000",
        sold: true,
        soldDate: "2025-05-20",
        soldPrice: "887000",
        bedroom: "2",
        bathroom: "1",
        livingArea: "945",
        lotSize: "6365",
        lotSizeAcre: "",
        yearBuild: "1926",
        thumb: true,
        pics: ["MLS_1.jpg", "MLS_2.jpg", "MLS_3.jpg", "MLS_4.jpg", "MLS_5.jpg", "MLS_6.jpg", "MLS_7.jpg", "MLS_8.jpg", "MLS_9.jpg", "MLS_10.jpg", "MLS_11.jpg", "MLS_12.jpg", "MLS_13.jpg", "MLS_14.jpg", "MLS_15.jpg", "MLS_16.jpg", "MLS_17.jpg", "MLS_18.jpg", "MLS_19.jpg", "MLS_20.jpg", "MLS_21.jpg", "MLS_22.jpg", "MLS_23.jpg", "MLS_24.jpg", "MLS_25.jpg", "MLS_26.jpg", "MLS_27.jpg", "MLS_28.jpg", "MLS_29.jpg", "MLS_30.jpg", "MLS_31.jpg", "MLS_32.jpg", "MLS_33.jpg", "MLS_34.jpg", "MLS_35.jpg", "MLS_36.jpg", "MLS_37.jpg"],
      },
      {
        id: "215ECommonwealth",
        title: "215 E Commonwealth Ave Apt A",
        price: "768000",
        sold: true,
        soldDate: "2025-02-11",
        soldPrice: "800000",
        bedroom: "3",
        bathroom: "3",
        livingArea: "1395",
        lotSize: "50690",
        lotSizeAcre: "",
        yearBuild: "",
        thumb: true,
        pics: ["MLS_1.jpg", "MLS_2.jpg", "MLS_3.jpg", "MLS_4.jpg", "MLS_5.jpg", "MLS_6.jpg", "MLS_7.jpg", "MLS_8.jpg", "MLS_9.jpg", "MLS_10.jpg", "MLS_11.jpg", "MLS_12.jpg", "MLS_13.jpg", "MLS_14.jpg", "MLS_15.jpg", "MLS_16.jpg", "MLS_17.jpg", "MLS_18.jpg", "MLS_19.jpg", "MLS_20.jpg", "MLS_21.jpg", "MLS_22.jpg", "MLS_23.jpg", "MLS_24.jpg", "MLS_25.jpg", "MLS_26.jpg", "MLS_27.jpg", "MLS_28.jpg", "MLS_29.jpg", "MLS_30.jpg", "MLS_31.jpg", "MLS_32.jpg", "MLS_33.jpg", "MLS_34.jpg", "MLS_35.jpg", "MLS_36.jpg", "MLS_37.jpg", "MLS_38.jpg"],
      },
      {
        id: "26OakCliff",
        title: "26 Oak Cliff Dr",
        price: "948000",
        sold: true,
        soldDate: "2025-01-17",
        soldPrice: "960000",
        bedroom: "4",
        bathroom: "2.5",
        livingArea: "1907",
        lotSize: "5501",
        lotSizeAcre: "",
        yearBuild: "1984",
        thumb: true,
        pics: ["MLS_1.jpg", "MLS_2.jpg", "MLS_3.jpg", "MLS_4.jpg", "MLS_5.jpg", "MLS_6.jpg", "MLS_7.jpg", "MLS_8.jpg", "MLS_9.jpg", "MLS_10.jpg", "MLS_11.jpg", "MLS_12.jpg", "MLS_13.jpg", "MLS_14.jpg", "MLS_15.jpg", "MLS_16.jpg", "MLS_17.jpg", "MLS_18.jpg", "MLS_19.jpg", "MLS_20.jpg", "MLS_21.jpg", "MLS_22.jpg", "MLS_23.jpg", "MLS_24.jpg", "MLS_25.jpg", "MLS_26.jpg", "MLS_27.jpg", "MLS_28.jpg", "MLS_29.jpg", "MLS_30.jpg", "MLS_31.jpg", "MLS_32.jpg", "MLS_33.jpg", "MLS_34.jpg", "MLS_35.jpg", "MLS_36.jpg", "MLS_37.jpg", "MLS_38.jpg", "MLS_39.jpg", "MLS_40.jpg", "MLS_41.jpg", "MLS_42.jpg", "MLS_43.jpg", "MLS_44.jpg", "MLS_45.jpg", "MLS_46.jpg", "MLS_47.jpg", "MLS_48.jpg", "MLS_49.jpg", "MLS_50.jpg", "MLS_51.jpg"],
      },
      {
        id: "720BanyanWay",
        title: "720 Banyan Way",
        price: "680000",
        sold: true,
        soldDate: "2025-12-17",
        soldPrice: "655000",
        bedroom: "3",
        bathroom: "3",
        livingArea: "1530",
        lotSize: "32025",
        lotSizeAcre: "",
        yearBuild: "2018",
        thumb: true,
        pics: ["MLS_1.jpg", "MLS_2.jpg", "MLS_3.jpg", "MLS_4.jpg", "MLS_5.jpg", "MLS_6.jpg", "MLS_7.jpg", "MLS_8.jpg", "MLS_9.jpg", "MLS_10.jpg", "MLS_11.jpg", "MLS_12.jpg", "MLS_13.jpg", "MLS_14.jpg", "MLS_15.jpg", "MLS_16.jpg", "MLS_17.jpg", "MLS_18.jpg", "MLS_19.jpg", "MLS_20.jpg", "MLS_21.jpg", "MLS_22.jpg", "MLS_23.jpg", "MLS_24.jpg", "MLS_25.jpg", "MLS_26.jpg", "MLS_27.jpg", "MLS_28.jpg", "MLS_29.jpg", "MLS_30.jpg", "MLS_31.jpg", "MLS_32.jpg", "MLS_33.jpg", "MLS_34.jpg", "MLS_35.jpg", "MLS_36.jpg", "MLS_37.jpg", "MLS_38.jpg", "MLS_39.jpg", "MLS_40.jpg", "MLS_41.jpg", "MLS_42.jpg", "MLS_43.jpg"],
      },
      {
        id: "5551sultanaA",
        title: "5551 Sultana Ave Unit A, Temple City, CA",
        price: "1280000",
        sold: true,
        soldDate: "2024-11-20",
        soldPrice: "1280000",
        bedroom: "4",
        bathroom: "4.5",
        livingArea: "1828",
        lotSize: "31607",
        lotSizeAcre: "",
        yearBuild: "",
        thumb: true,
        preview: ["MLS_4.jpg", "MLS_6.jpg", "MLS_8.jpg", "MLS_12.jpg", "MLS_22.jpg", "MLS_26.jpg", "MLS_29.jpg", "MLS_30.jpg", "MLS_34.jpg", "MLS_38.jpg"],
        pics: ["MLS_1.jpg", "MLS_2.jpg", "MLS_3.jpg", "MLS_4.jpg", "MLS_5.jpg", "MLS_6.jpg", "MLS_7.jpg", "MLS_8.jpg", "MLS_9.jpg", "MLS_10.jpg", "MLS_11.jpg", "MLS_12.jpg", "MLS_13.jpg", "MLS_14.jpg", "MLS_15.jpg", "MLS_16.jpg", "MLS_17.jpg", "MLS_18.jpg", "MLS_19.jpg", "MLS_20.jpg", "MLS_21.jpg", "MLS_22.jpg", "MLS_23.jpg", "MLS_24.jpg", "MLS_25.jpg", "MLS_26.jpg", "MLS_27.jpg", "MLS_28.jpg", "MLS_29.jpg", "MLS_30.jpg", "MLS_31.jpg", "MLS_32.jpg", "MLS_33.jpg", "MLS_34.jpg", "MLS_35.jpg", "MLS_36.jpg", "MLS_37.jpg", "MLS_38.jpg", "MLS_39.jpg", "MLS_40.jpg", "MLS_41.jpg", "MLS_42.jpg", "MLS_43.jpg"],
      },
      {
        id: "39fano",
        title: "39 Fano St Unit A, Arcadia, CA",
        price: "1098000",
        sold: true,
        soldDate: "2024-09-24",
        soldPrice: "1120000",
        bedroom: "3",
        bathroom: "2.5",
        livingArea: "1731",
        lotSize: "7901",
        lotSizeAcre: "",
        yearBuild: "",
        thumb: true,
        preview: ["MLS_1.jpg", "MLS_5.jpg", "MLS_9.jpg", "MLS_12.jpg", "MLS_14.jpg", "MLS_16.jpg", "MLS_17.jpg", "MLS_18.jpg", "MLS_19.jpg", "MLS_20.jpg", "MLS_21.jpg", "MLS_22.jpg", "MLS_23.jpg", "MLS_24.jpg", "MLS_25.jpg", "MLS_26.jpg", "MLS_27.jpg", "MLS_28.jpg"],
        pics: ["MLS_1.jpg", "MLS_2.jpg", "MLS_3.jpg", "MLS_4.jpg", "MLS_5.jpg", "MLS_6.jpg", "MLS_7.jpg", "MLS_8.jpg", "MLS_9.jpg", "MLS_10.jpg", "MLS_11.jpg", "MLS_12.jpg", "MLS_13.jpg", "MLS_14.jpg", "MLS_15.jpg", "MLS_16.jpg", "MLS_17.jpg", "MLS_18.jpg", "MLS_19.jpg", "MLS_20.jpg", "MLS_21.jpg", "MLS_22.jpg", "MLS_23.jpg", "MLS_24.jpg", "MLS_25.jpg", "MLS_26.jpg", "MLS_27.jpg", "MLS_28.jpg", "MLS_29.jpg", "MLS_30.jpg", "MLS_31.jpg", "MLS_32.jpg", "MLS_33.jpg", "MLS_34.jpg"],
      },
      {
        id: "106NChapelAve",
        title: "106 N Chapel Ave Apt 10",
        price: "698000",
        sold: true,
        soldDate: "2024-11-15",
        soldPrice: "715000",
        bedroom: "2",
        bathroom: "2",
        livingArea: "1236",
        lotSize: "54093",
        lotSizeAcre: "",
        yearBuild: "",
        thumb: true,
        pics: ["MLS_1.jpg", "MLS_2.jpg", "MLS_3.jpg", "MLS_4.jpg", "MLS_5.jpg", "MLS_6.jpg", "MLS_7.jpg", "MLS_8.jpg", "MLS_9.jpg", "MLS_10.jpg", "MLS_11.jpg", "MLS_12.jpg", "MLS_13.jpg", "MLS_14.jpg", "MLS_15.jpg", "MLS_16.jpg", "MLS_17.jpg", "MLS_18.jpg", "MLS_19.jpg", "MLS_20.jpg", "MLS_21.jpg", "MLS_22.jpg", "MLS_23.jpg", "MLS_24.jpg", "MLS_25.jpg", "MLS_26.jpg", "MLS_27.jpg", "MLS_28.jpg", "MLS_29.jpg", "MLS_30.jpg", "MLS_31.jpg", "MLS_32.jpg", "MLS_33.jpg", "MLS_34.jpg", "MLS_35.jpg", "MLS_36.jpg"],
      },
      {
        id: "1716PepperB",
        title: "1716 Pepper St #B, Alhambra, CA 91801",
        price: "718000",
        sold: true,
        soldDate: "2024-10-30",
        soldPrice: "750000",
        bedroom: "3",
        bathroom: "3",
        livingArea: "1370",
        lotSize: "20006",
        lotSizeAcre: "",
        yearBuild: "1986",
        thumb: true,
        pics: ["MLS_1.jpg", "MLS_2.jpg", "MLS_3.jpg", "MLS_4.jpg", "MLS_5.jpg", "MLS_6.jpg", "MLS_7.jpg", "MLS_8.jpg", "MLS_9.jpg", "MLS_10.jpg", "MLS_11.jpg", "MLS_12.jpg", "MLS_13.jpg", "MLS_14.jpg", "MLS_15.jpg", "MLS_16.jpg", "MLS_17.jpg", "MLS_18.jpg", "MLS_19.jpg", "MLS_20.jpg", "MLS_21.jpg", "MLS_22.jpg", "MLS_23.jpg", "MLS_24.jpg", "MLS_25.jpg", "MLS_26.jpg", "MLS_27.jpg", "MLS_28.jpg", "MLS_29.jpg", "MLS_30.jpg", "MLS_31.jpg", "MLS_32.jpg", "MLS_33.jpg", "MLS_34.jpg", "MLS_35.jpg"],
      },
      {
        id: "27980sWestern",
        title: "27980 S Western Ave, San Pedro, CA",
        price: "538000",
        sold: true,
        soldDate: "2024-10-23",
        soldPrice: "530000",
        bedroom: "2",
        bathroom: "2",
        livingArea: "1174",
        lotSize: "49818",
        lotSizeAcre: "",
        yearBuild: "",
        thumb: true,
        pics: ["MLS_1.jpg", "MLS_2.jpg", "MLS_3.jpg", "MLS_4.jpg", "MLS_5.jpg", "MLS_6.jpg", "MLS_7.jpg", "MLS_8.jpg", "MLS_9.jpg", "MLS_10.jpg", "MLS_11.jpg", "MLS_12.jpg", "MLS_13.jpg", "MLS_14.jpg", "MLS_15.jpg", "MLS_16.jpg", "MLS_17.jpg", "MLS_18.jpg", "MLS_19.jpg", "MLS_20.jpg", "MLS_21.jpg", "MLS_22.jpg", "MLS_23.jpg", "MLS_24.jpg", "MLS_25.jpg", "MLS_26.jpg", "MLS_27.jpg", "MLS_28.jpg", "MLS_29.jpg", "MLS_30.jpg", "MLS_31.jpg", "MLS_32.jpg", "MLS_33.jpg", "MLS_34.jpg", "MLS_35.jpg", "MLS_36.jpg", "MLS_37.jpg", "MLS_38.jpg"],
      },
      {
        id: "451Woodruff",
        title: "451 W Woodruff Ave",
        price: "2980000",
        sold: true,
        soldDate: "2024-08-01",
        soldPrice: "3020000",
        bedroom: "6",
        bathroom: "5",
        livingArea: "5352",
        lotSize: "",
        lotSizeAcre: "0.29",
        yearBuild: "1997",
        thumb: true,
        preview: ["MLS_3.jpg", "MLS_7.jpg", "MLS_9.jpg", "MLS_10.jpg", "MLS_11.jpg", "MLS_12.jpg", "MLS_13.jpg", "MLS_14.jpg", "MLS_15.jpg", "MLS_16.jpg", "MLS_17.jpg", "MLS_20.jpg", "MLS_25.jpg", "MLS_26.jpg", "MLS_27.jpg", "MLS_50.jpg", "MLS_51.jpg", "MLS_52.jpg", "MLS_53.jpg", "MLS_54.jpg", "MLS_69.jpg"],
        pics: [
          "MLS_3.jpg",
          "MLS_1.jpg",
          "MLS_2.jpg",
          "MLS_4.jpg",
          "MLS_5.jpg",
          "MLS_6.jpg",
          "MLS_7.jpg",
          "MLS_8.jpg",
          "MLS_9.jpg",
          "MLS_10.jpg",
          "MLS_11.jpg",
          "MLS_12.jpg",
          "MLS_13.jpg",
          "MLS_14.jpg",
          "MLS_15.jpg",
          "MLS_16.jpg",
          "MLS_17.jpg",
          "MLS_18.jpg",
          "MLS_19.jpg",
          "MLS_20.jpg",
          "MLS_21.jpg",
          "MLS_22.jpg",
          "MLS_23.jpg",
          "MLS_24.jpg",
          "MLS_25.jpg",
          "MLS_26.jpg",
          "MLS_27.jpg",
          "MLS_28.jpg",
          "MLS_29.jpg",
          "MLS_30.jpg",
          "MLS_31.jpg",
          "MLS_32.jpg",
          "MLS_33.jpg",
          "MLS_34.jpg",
          "MLS_35.jpg",
          "MLS_36.jpg",
          "MLS_37.jpg",
          "MLS_38.jpg",
          "MLS_39.jpg",
          "MLS_40.jpg",
          "MLS_41.jpg",
          "MLS_42.jpg",
          "MLS_43.jpg",
          "MLS_44.jpg",
          "MLS_45.jpg",
          "MLS_46.jpg",
          "MLS_47.jpg",
          "MLS_48.jpg",
          "MLS_49.jpg",
          "MLS_50.jpg",
          "MLS_51.jpg",
          "MLS_52.jpg",
          "MLS_53.jpg",
          "MLS_54.jpg",
          "MLS_55.jpg",
          "MLS_56.jpg",
          "MLS_57.jpg",
          "MLS_58.jpg",
          "MLS_59.jpg",
          "MLS_60.jpg",
          "MLS_61.jpg",
          "MLS_62.jpg",
          "MLS_63.jpg",
          "MLS_64.jpg",
          "MLS_65.jpg",
          "MLS_66.jpg",
          "MLS_67.jpg",
          "MLS_68.jpg",
          "MLS_69.jpg",
          "MLS_70.jpg",
          "MLS_71.jpg",
          "MLS_72.jpg",
          "MLS_73.jpg",
          "MLS_74.jpg",
          "MLS_75.jpg",
          "MLS_76.jpg",
          "451Woodruff1.jpg",
          "451Woodruff2.jpg",
          "451Woodruff3.jpg",
          "451Woodruff4.jpg",
          "451Woodruff5.jpg",
        ],
      },
      {
        id: "220nStoneman",
        title: "220 N Stoneman Ave Unit G",
        price: "718000",
        sold: true,
        soldDate: "2024-08-07",
        soldPrice: "708000",
        bedroom: "2",
        bathroom: "2.5",
        livingArea: "1340",
        lotSize: "41948",
        lotSizeAcre: "",
        yearBuild: "",
        thumb: true,
        pics: ["MLS_1.jpg", "MLS_2.jpg", "MLS_3.jpg", "MLS_4.jpg", "MLS_5.jpg", "MLS_6.jpg", "MLS_7.jpg", "MLS_8.jpg", "MLS_9.jpg", "MLS_10.jpg", "MLS_11.jpg", "MLS_12.jpg", "MLS_13.jpg", "MLS_14.jpg", "MLS_15.jpg", "MLS_16.jpg", "MLS_17.jpg", "MLS_18.jpg", "MLS_19.jpg", "MLS_20.jpg", "MLS_21.jpg", "MLS_22.jpg", "MLS_23.jpg", "MLS_24.jpg", "MLS_25.jpg", "MLS_26.jpg", "MLS_27.jpg", "MLS_28.jpg", "MLS_29.jpg", "MLS_30.jpg", "MLS_31.jpg", "MLS_32.jpg", "MLS_33.jpg", "MLS_34.jpg", "MLS_35.jpg", "MLS_36.jpg"],
      },
      {
        id: "505N2ndst",
        title: "505 N 2nd St #A",
        price: "798000",
        sold: true,
        soldDate: "2024-06-26",
        soldPrice: "825000",
        bedroom: "3",
        bathroom: "2.5",
        livingArea: "1659",
        lotSize: "",
        lotSizeAcre: "0.38",
        yearBuild: "",
        thumb: true,
        pics: ["MLS_1.jpg", "MLS_2.jpg", "MLS_3.jpg", "MLS_4.jpg", "MLS_5.jpg", "MLS_6.jpg", "MLS_7.jpg", "MLS_8.jpg", "MLS_9.jpg", "MLS_10.jpg", "MLS_11.jpg", "MLS_12.jpg", "MLS_13.jpg", "MLS_14.jpg", "MLS_15.jpg", "MLS_16.jpg", "MLS_17.jpg", "MLS_18.jpg", "MLS_19.jpg", "MLS_20.jpg", "MLS_21.jpg", "MLS_22.jpg", "MLS_23.jpg", "MLS_24.jpg", "MLS_25.jpg", "MLS_26.jpg", "MLS_27.jpg", "MLS_28.jpg", "MLS_29.jpg", "MLS_30.jpg", "MLS_31.jpg", "MLS_32.jpg", "MLS_33.jpg", "MLS_34.jpg", "MLS_35.jpg", "MLS_36.jpg", "MLS_37.jpg", "MLS_38.jpg", "MLS_39.jpg", "MLS_40.jpg"],
      },
      {
        id: "2410cumberland",
        title: "2410 Cumberland Rd",
        price: "3380000",
        sold: true,
        soldDate: "2024-03-26",
        soldPrice: "2900000",
        bedroom: "5",
        bathroom: "5",
        livingArea: "3049",
        lotSize: "",
        lotSizeAcre: "0.29",
        yearBuild: "",
        thumb: true,
        preview: ["MLS_1.jpg", "MLS_13.jpg", "MLS_14.jpg", "MLS_26.jpg", "MLS_34.jpg", "MLS_52.jpg", "MLS_56.jpg"],
        pics: [
          "MLS_1.jpg",
          "MLS_2.jpg",
          "MLS_3.jpg",
          "MLS_4.jpg",
          "MLS_5.jpg",
          "MLS_6.jpg",
          "MLS_7.jpg",
          "MLS_8.jpg",
          "MLS_9.jpg",
          "MLS_10.jpg",
          "MLS_11.jpg",
          "MLS_12.jpg",
          "MLS_13.jpg",
          "MLS_14.jpg",
          "MLS_15.jpg",
          "MLS_16.jpg",
          "MLS_17.jpg",
          "MLS_18.jpg",
          "MLS_19.jpg",
          "MLS_20.jpg",
          "MLS_21.jpg",
          "MLS_22.jpg",
          "MLS_23.jpg",
          "MLS_24.jpg",
          "MLS_25.jpg",
          "MLS_26.jpg",
          "MLS_27.jpg",
          "MLS_28.jpg",
          "MLS_29.jpg",
          "MLS_30.jpg",
          "MLS_31.jpg",
          "MLS_32.jpg",
          "MLS_33.jpg",
          "MLS_34.jpg",
          "MLS_35.jpg",
          "MLS_37.jpg",
          "MLS_38.jpg",
          "MLS_39.jpg",
          "MLS_40.jpg",
          "MLS_41.jpg",
          "MLS_42.jpg",
          "MLS_43.jpg",
          "MLS_44.jpg",
          "MLS_45.jpg",
          "MLS_46.jpg",
          "MLS_47.jpg",
          "MLS_48.jpg",
          "MLS_49.jpg",
          "MLS_50.jpg",
          "MLS_51.jpg",
          "MLS_52.jpg",
          "MLS_53.jpg",
          "MLS_54.jpg",
          "MLS_55.jpg",
          "MLS_56.jpg",
          "MLS_57.jpg",
          "MLS_58.jpg",
          "MLS_59.jpg",
          "MLS_60.jpg",
          "MLS_61.jpg",
          "MLS_62.jpg",
          "MLS_63.jpg",
          "MLS_64.jpg",
          "MLS_65.jpg",
          "MLS_66.jpg",
          "MLS_67.jpg",
          "MLS_68.jpg",
          "MLS_69.jpg",
          "MLS_70.jpg",
          "MLS_71.jpg",
          "MLS_72.jpg",
          "MLS_73.jpg",
          "MLS_74.jpg",
          "MLS_75.jpg",
        ],
      },
      {
        id: "5564TempleCity",
        title: "5564 Temple City Blvd",
        price: "598000",
        sold: true,
        soldDate: "2024-04-26",
        soldPrice: "628000",
        bedroom: "2",
        bathroom: "1",
        livingArea: "897",
        lotSize: "",
        lotSizeAcre: "2.02",
        yearBuild: "",
        thumb: true,
        pics: ["MLS_1.jpg", "MLS_2.jpg", "MLS_3.jpg", "MLS_4.jpg", "MLS_5.jpg", "MLS_6.jpg", "MLS_7.jpg", "MLS_8.jpg", "MLS_9.jpg", "MLS_10.jpg", "MLS_11.jpg", "MLS_12.jpg", "MLS_13.jpg", "MLS_14.jpg", "MLS_15.jpg", "MLS_16.jpg", "MLS_17.jpg", "MLS_18.jpg", "MLS_19.jpg", "MLS_20.jpg", "MLS_21.jpg", "MLS_22.jpg", "MLS_23.jpg", "MLS_24.jpg", "MLS_25.jpg", "MLS_26.jpg", "MLS_27.jpg", "MLS_28.jpg", "MLS_29.jpg", "MLS_30.jpg", "MLS_31.jpg"],
      },
      {
        id: "2400Elpaseo",
        title: "2400 El Paseo",
        price: "598000",
        sold: true,
        soldDate: "2024-04-26",
        soldPrice: "628000",
        bedroom: "3",
        bathroom: "2",
        livingArea: "2028",
        lotSize: "6364",
        lotSizeAcre: "",
        yearBuild: "",
        thumb: true,
        pics: ["MLS_1.jpg", "MLS_2.jpg", "MLS_3.jpg", "MLS_4.jpg", "MLS_5.jpg", "MLS_6.jpg", "MLS_7.jpg", "MLS_8.jpg", "MLS_9.jpg", "MLS_10.jpg", "MLS_11.jpg", "MLS_12.jpg", "MLS_13.jpg", "MLS_14.jpg", "MLS_15.jpg", "MLS_16.jpg", "MLS_17.jpg", "MLS_18.jpg", "MLS_19.jpg", "MLS_20.jpg", "MLS_21.jpg", "MLS_22.jpg", "MLS_23.jpg", "MLS_24.jpg", "MLS_25.jpg", "MLS_26.jpg", "MLS_27.jpg", "MLS_28.jpg", "MLS_29.jpg", "MLS_30.jpg", "MLS_31.jpg", "MLS_32.jpg", "MLS_33.jpg", "MLS_34.jpg", "MLS_35.jpg", "MLS_36.jpg", "MLS_37.jpg", "MLS_38.jpg", "MLS_39.jpg", "MLS_40.jpg", "MLS_41.jpg", "MLS_42.jpg", "MLS_43.jpg", "MLS_44.jpg", "MLS_45.jpg", "MLS_46.jpg"],
      },
      {
        id: "105EBeaconB",
        title: "105 E Beacon St #B",
        price: "",
        sold: true,
        soldDate: "2024-03-05",
        soldPrice: "7500000",
        bedroom: "3",
        bathroom: "3",
        livingArea: "1350",
        lotSize: "13242",
        lotSizeAcre: "",
        yearBuild: "",
        thumb: true,
        pics: ["MLS_1.jpg", "MLS_2.jpg", "MLS_3.jpg", "MLS_4.jpg", "MLS_5.jpg", "MLS_6.jpg", "MLS_7.jpg", "MLS_8.jpg", "MLS_9.jpg", "MLS_10.jpg", "MLS_11.jpg", "MLS_12.jpg", "MLS_13.jpg", "MLS_14.jpg", "MLS_15.jpg", "MLS_16.jpg", "MLS_17.jpg", "MLS_18.jpg", "MLS_19.jpg", "MLS_20.jpg", "MLS_21.jpg", "MLS_22.jpg", "MLS_23.jpg", "MLS_24.jpg", "MLS_25.jpg", "MLS_26.jpg", "MLS_27.jpg", "MLS_28.jpg", "MLS_29.jpg", "MLS_30.jpg", "MLS_31.jpg", "MLS_32.jpg", "MLS_33.jpg"],
      },
      {
        id: "21214sundance",
        title: "21214 Sundance St",
        price: "1228000",
        sold: true,
        soldDate: "2023-11-27",
        soldPrice: "1280000",
        bedroom: "4",
        bathroom: "3",
        livingArea: "2219",
        lotSize: "8339",
        yearBuild: "",
        thumb: true,
        pics: ["MLS_4.jpg", "MLS_5.jpg", "MLS_7.jpg", "MLS_8.jpg", "MLS_10.jpg", "MLS_11.jpg", "MLS_12.jpg", "MLS_13.jpg", "MLS_14.jpg", "MLS_15.jpg", "MLS_16.jpg", "MLS_17.jpg", "MLS_18.jpg", "MLS_19.jpg", "MLS_20.jpg", "MLS_21.jpg", "MLS_22.jpg", "MLS_23.jpg", "MLS_24.jpg", "MLS_25.jpg", "MLS_26.jpg", "MLS_27.jpg", "MLS_28.jpg", "MLS_29.jpg", "MLS_30.jpg", "MLS_31.jpg", "MLS_32.jpg", "MLS_33.jpg", "MLS_34.jpg", "MLS_35.jpg", "MLS_36.jpg", "MLS_37.jpg", "MLS_38.jpg", "MLS_39.jpg", "MLS_40.jpg", "MLS_41.jpg", "MLS_42.jpg", "MLS_43.jpg", "MLS_44.jpg", "MLS_45.jpg", "MLS_46.jpg", "MLS_47.jpg", "MLS_48.jpg", "MLS_49.jpg", "MLS_50.jpg", "MLS_52.jpg", "MLS_53.jpg", "MLS_54.jpg", "MLS_55.jpg", "MLS_56.jpg", "MLS_57.jpg", "MLS_58.jpg", "MLS_59.jpg"],
      },

      {
        id: "1715saintalbans",
        title: "1715 St Albans Rd, San Marino, CA",
        price: "3980000",
        sold: true,
        soldDate: "2023-11-28",
        soldPrice: "3850000",
        bedroom: "4",
        bathroom: "3.5",
        livingArea: "3273",
        lotSize: "",
        lotSizeAcre: "0.41",
        yearBuild: "",
        thumb: true,
        preview: ["MLS_1.jpg", "MLS_2.jpg", "MLS_6.jpg", "MLS_8.jpg", "MLS_13.jpg", "MLS_20.jpg", "MLS_21.jpg", "MLS_24.jpg"],
        pics: ["MLS_1.jpg", "MLS_2.jpg", "MLS_3.jpg", "MLS_4.jpg", "MLS_5.jpg", "MLS_6.jpg", "MLS_7.jpg", "MLS_8.jpg", "MLS_9.jpg", "MLS_10.jpg", "MLS_11.jpg", "MLS_12.jpg", "MLS_13.jpg", "MLS_14.jpg", "MLS_15.jpg", "MLS_16.jpg", "MLS_17.jpg", "MLS_18.jpg", "MLS_19.jpg", "MLS_20.jpg", "MLS_21.jpg", "MLS_22.jpg", "MLS_23.jpg", "MLS_24.jpg", "MLS_25.jpg", "MLS_26.jpg", "MLS_27.jpg", "MLS_28.jpg", "MLS_29.jpg", "MLS_30.jpg", "MLS_31.jpg", "MLS_32.jpg", "MLS_33.jpg", "MLS_34.jpg", "MLS_35.jpg", "MLS_36.jpg", "MLS_37.jpg", "MLS_38.jpg", "MLS_39.jpg", "MLS_40.jpg", "MLS_41.jpg", "MLS_42.jpg", "MLS_43.jpg", "MLS_44.jpg", "MLS_45.jpg", "MLS_46.jpg", "MLS_47.jpg", "MLS_48.jpg", "MLS_49.jpg", "MLS_50.jpg", "MLS_51.jpg", "MLS_52.jpg", "MLS_53.jpg", "MLS_54.jpg", "MLS_55.jpg"],
      },
      {
        id: "1445oakgrove",
        title: "1445 Oak Grove Ave",
        price: "4450000",
        sold: true,
        soldDate: "2023-11-15",
        soldPrice: "3908000",
        bedroom: "4",
        bathroom: "6",
        livingArea: "4978",
        lotSize: "17860",
        yearBuild: "",
        thumb: true,
        pics: [
          "MLS_1.jpg",
          "MLS_2.jpg",
          "MLS_3.jpg",
          "MLS_4.jpg",
          "MLS_5.jpg",
          "MLS_6.jpg",
          "MLS_7.jpg",
          "MLS_8.jpg",
          "MLS_9.jpg",
          "MLS_10.jpg",
          "MLS_11.jpg",
          "MLS_12.jpg",
          "MLS_13.jpg",
          "MLS_14.jpg",
          "MLS_15.jpg",
          "MLS_16.jpg",
          "MLS_17.jpg",
          "MLS_18.jpg",
          "MLS_19.jpg",
          "MLS_20.jpg",
          "MLS_21.jpg",
          "MLS_22.jpg",
          "MLS_23.jpg",
          "MLS_24.jpg",
          "MLS_25.jpg",
          "MLS_26.jpg",
          "MLS_27.jpg",
          "MLS_28.jpg",
          "MLS_29.jpg",
          "MLS_30.jpg",
          "MLS_31.jpg",
          "MLS_32.jpg",
          "MLS_33.jpg",
          "MLS_34.jpg",
          "MLS_35.jpg",
          "MLS_36.jpg",
          "MLS_37.jpg",
          "MLS_38.jpg",
          "MLS_39.jpg",
          "MLS_40.jpg",
          "MLS_41.jpg",
          "MLS_42.jpg",
          "MLS_43.jpg",
          "MLS_44.jpg",
          "MLS_45.jpg",
          "MLS_46.jpg",
          "MLS_47.jpg",
          "MLS_48.jpg",
          "MLS_49.jpg",
          "MLS_50.jpg",
          "MLS_51.jpg",
          "MLS_52.jpg",
          "MLS_53.jpg",
          "MLS_54.jpg",
          "MLS_55.jpg",
          "MLS_56.jpg",
          "MLS_57.jpg",
          "MLS_58.jpg",
          "MLS_59.jpg",
          "MLS_60.jpg",
          "MLS_61.jpg",
          "MLS_62.jpg",
          "MLS_63.jpg",
          "MLS_64.jpg",
          "MLS_65.jpg",
          "MLS_66.jpg",
          "MLS_67.jpg",
          "MLS_68.jpg",
          "MLS_69.jpg",
          "MLS_70.jpg",
          "MLS_71.jpg",
          "MLS_72.jpg",
          "MLS_73.jpg",
          "MLS_74.jpg",
        ],
      },
      {
        id: "11373Lemoncrest",
        title: "11373 Lemoncrest Ave",
        price: "990000",
        sold: true,
        soldDate: "2023-07-28",
        soldPrice: "1070000",
        bedroom: "3",
        bathroom: "2.5",
        livingArea: "1944",
        lotSize: "",
        lotSizeAcre: "0.26",
        yearBuild: "",
        thumb: true,
        pics: ["MLS_1.jpg", "MLS_2.jpg", "MLS_3.jpg", "MLS_4.jpg", "MLS_5.jpg", "MLS_6.jpg", "MLS_7.jpg", "MLS_8.jpg", "MLS_9.jpg", "MLS_10.jpg", "MLS_11.jpg", "MLS_12.jpg", "MLS_13.jpg", "MLS_14.jpg", "MLS_15.jpg", "MLS_16.jpg", "MLS_17.jpg", "MLS_18.jpg", "MLS_19.jpg", "MLS_20.jpg", "MLS_21.jpg", "MLS_22.jpg", "MLS_23.jpg", "MLS_24.jpg", "MLS_25.jpg", "MLS_26.jpg", "MLS_27.jpg", "MLS_28.jpg", "MLS_29.jpg", "MLS_30.jpg", "MLS_31.jpg", "MLS_32.jpg", "MLS_33.jpg", "MLS_34.jpg", "MLS_35.jpg", "MLS_36.jpg", "MLS_37.jpg", "MLS_38.jpg"],
      },
      {
        id: "1817chapel",
        title: "1817 S Chapel Ave",
        price: "948000",
        sold: true,
        soldDate: "2023-09-19",
        soldPrice: "1150000",
        bedroom: "3",
        bathroom: "1.5",
        livingArea: "1491",
        lotSize: "6750",
        yearBuild: "",
        thumb: true,
        pics: ["MLS_1.jpg", "MLS_2.jpg", "MLS_3.jpg", "MLS_4.jpg", "MLS_5.jpg", "MLS_6.jpg", "MLS_7.jpg", "MLS_8.jpg", "MLS_9.jpg", "MLS_10.jpg", "MLS_11.jpg", "MLS_12.jpg", "MLS_13.jpg", "MLS_14.jpg", "MLS_15.jpg", "MLS_16.jpg", "MLS_17.jpg", "MLS_18.jpg", "MLS_19.jpg", "MLS_20.jpg", "MLS_21.jpg", "MLS_22.jpg", "MLS_23.jpg", "MLS_24.jpg", "MLS_25.jpg", "MLS_26.jpg", "MLS_27.jpg", "MLS_28.jpg", "MLS_29.jpg", "MLS_30.jpg", "MLS_31.jpg", "MLS_32.jpg", "MLS_33.jpg", "MLS_34.jpg", "MLS_35.jpg", "MLS_36.jpg", "MLS_37.jpg", "MLS_38.jpg", "MLS_39.jpg", "MLS_40.jpg", "MLS_41.jpg", "MLS_42.jpg", "MLS_43.jpg", "MLS_44.jpg", "MLS_45.jpg", "MLS_46.jpg", "MLS_47.jpg", "MLS_48.jpg", "MLS_49.jpg", "MLS_50.jpg"],
      },
      {
        id: "1445waverly",
        title: "1445 Waverly Rd, San Marino, CA 91108",
        price: "4498000",
        sold: true,
        soldDate: "2023-10-17",
        soldPrice: "4300000",
        bedroom: "4",
        bathroom: "5",
        livingArea: "4682",
        lotSize: "15739",
        yearBuild: "1948",
        thumb: true,
        // preview:['MLS_01.jpg','MLS_2.jpg','MLS_4.jpg','MLS_8.jpg','MLS_11.jpg','MLS_15.jpg','MLS_18.jpg','MLS_20.jpg','MLS_24.jpg','MLS_27.jpg','MLS_2.jpg',],
        pics: ["MLS_01.jpg", "MLS_02.jpg", "MLS_1.jpg", "MLS_2.jpg", "MLS_3.jpg", "MLS_4.jpg", "MLS_5.jpg", "MLS_6.jpg", "MLS_7.jpg", "MLS_8.jpg", "MLS_9.jpg", "MLS_10.jpg", "MLS_11.jpg", "MLS_12.jpg", "MLS_13.jpg", "MLS_14.jpg", "MLS_15.jpg", "MLS_16.jpg", "MLS_17.jpg", "MLS_18.jpg", "MLS_19.jpg", "MLS_20.jpg", "MLS_21.jpg", "MLS_22.jpg", "MLS_23.jpg", "MLS_24.jpg", "MLS_25.jpg", "MLS_26.jpg", "MLS_27.jpg", "MLS_28.jpg", "MLS_29.jpg", "MLS_30.jpg", "MLS_31.jpg", "MLS_32.jpg", "MLS_33.jpg", "MLS_34.jpg", "MLS_35.jpg", "MLS_36.jpg", "MLS_37.jpg", "MLS_38.jpg", "MLS_39.jpg", "MLS_40.jpg", "MLS_45.jpg", "MLS_46.jpg", "MLS_47.jpg", "MLS_48.jpg", "MLS_49.jpg", "MLS_50.jpg"],
      },
      {
        id: "1502WGlenmere",
        title: "1502 W Glenmere Street",
        price: "748000",
        sold: true,
        soldDate: "2023-05-17",
        soldPrice: "797000",
        bedroom: "3",
        bathroom: "2",
        livingArea: "1470",
        lotSize: "9261",
        yearBuild: "",
        thumb: true,
        pics: ["MLS_1.jpg", "MLS_2.jpg", "MLS_3.jpg", "MLS_4.jpg", "MLS_5.jpg", "MLS_6.jpg", "MLS_7.jpg", "MLS_8.jpg", "MLS_9.jpg", "MLS_10.jpg", "MLS_11.jpg", "MLS_12.jpg", "MLS_13.jpg", "MLS_14.jpg", "MLS_15.jpg", "MLS_16.jpg", "MLS_17.jpg", "MLS_18.jpg", "MLS_19.jpg", "MLS_20.jpg", "MLS_21.jpg", "MLS_22.jpg", "MLS_23.jpg", "MLS_24.jpg", "MLS_25.jpg", "MLS_26.jpg", "MLS_27.jpg", "MLS_28.jpg", "MLS_29.jpg", "MLS_30.jpg", "MLS_31.jpg", "MLS_32.jpg", "MLS_33.jpg", "MLS_34.jpg", "MLS_35.jpg", "MLS_36.jpg", "MLS_37.jpg", "MLS_38.jpg", "MLS_39.jpg", "MLS_40.jpg", "MLS_41.jpg", "MLS_42.jpg", "MLS_43.jpg", "MLS_44.jpg", "MLS_45.jpg", "MLS_46.jpg", "MLS_47.jpg", "MLS_48.jpg", "MLS_49.jpg"],
      },
      {
        id: "2275SOakKnoll",
        title: "2275 S Oak Knoll Ave, San Marino, CA",
        price: "3690000",
        sold: true,
        soldDate: "2023-05-10",
        soldPrice: "3545000",
        bedroom: "4",
        bathroom: "4",
        livingArea: "3150",
        lotSize: "27486",
        yearBuild: "",
        thumb: true,
        preview: ["MLS_1.jpg", "MLS_2.jpg", "MLS_3.jpg", "MLS_5.jpg", "MLS_6.jpg", "MLS_11.jpg", "MLS_12.jpg", "MLS_13.jpg", "MLS_14.jpg", "MLS_16.jpg", "MLS_18.jpg", "MLS_21.jpg", "MLS_23.jpg", "MLS_25.jpg", "MLS_26.jpg", "MLS_37.jpg", "MLS_39.jpg", "MLS_43.jpg", "MLS_44.jpg", "MLS_45.jpg"],
        pics: [
          "MLS_1.jpg",
          "MLS_2.jpg",
          "MLS_3.jpg",
          "MLS_4.jpg",
          "MLS_5.jpg",
          "MLS_6.jpg",
          "MLS_7.jpg",
          "MLS_8.jpg",
          "MLS_9.jpg",
          "MLS_10.jpg",
          "MLS_11.jpg",
          "MLS_12.jpg",
          "MLS_13.jpg",
          "MLS_14.jpg",
          "MLS_15.jpg",
          "MLS_16.jpg",
          "MLS_17.jpg",
          "MLS_18.jpg",
          "MLS_19.jpg",
          "MLS_20.jpg",
          "MLS_21.jpg",
          "MLS_22.jpg",
          "MLS_23.jpg",
          "MLS_24.jpg",
          "MLS_25.jpg",
          "MLS_26.jpg",
          "MLS_27.jpg",
          "MLS_28.jpg",
          "MLS_29.jpg",
          "MLS_30.jpg",
          "MLS_31.jpg",
          "MLS_32.jpg",
          "MLS_33.jpg",
          "MLS_34.jpg",
          "MLS_35.jpg",
          "MLS_36.jpg",
          "MLS_37.jpg",
          "MLS_38.jpg",
          "MLS_39.jpg",
          "MLS_40.jpg",
          "MLS_41.jpg",
          "MLS_42.jpg",
          "MLS_43.jpg",
          "MLS_44.jpg",
          "MLS_45.jpg",
          "MLS_46.jpg",
          "MLS_47.jpg",
          "MLS_48.jpg",
          "MLS_49.jpg",
          "MLS_50.jpg",
          "MLS_51.jpg",
          "MLS_52.jpg",
          "MLS_53.jpg",
          "MLS_54.jpg",
          "MLS_55.jpg",
          "MLS_56.jpg",
          "MLS_57.jpg",
        ],
      },
      {
        id: "5556BaldwinAve",
        title: "5556 Baldwin Ave",
        price: "1198000",
        sold: true,
        soldDate: "2023-05-10",
        soldPrice: "1265000",
        bedroom: "3",
        bathroom: "2",
        livingArea: "1956",
        lotSize: "7099",
        yearBuild: "",
        thumb: true,
        pics: ["MLS_1.jpg", "MLS_2.jpg", "MLS_3.jpg", "MLS_4.jpg", "MLS_5.jpg", "MLS_6.jpg", "MLS_7.jpg", "MLS_8.jpg", "MLS_9.jpg", "MLS_10.jpg", "MLS_11.jpg", "MLS_12.jpg", "MLS_13.jpg", "MLS_14.jpg", "MLS_15.jpg", "MLS_16.jpg", "MLS_17.jpg", "MLS_18.jpg", "MLS_19.jpg", "MLS_20.jpg", "MLS_21.jpg", "MLS_22.jpg", "MLS_23.jpg", "MLS_24.jpg", "MLS_25.jpg", "MLS_26.jpg", "MLS_27.jpg", "MLS_28.jpg", "MLS_29.jpg", "MLS_30.jpg", "MLS_31.jpg", "MLS_32.jpg", "MLS_33.jpg", "MLS_34.jpg", "MLS_35.jpg", "MLS_36.jpg", "MLS_37.jpg", "MLS_38.jpg", "MLS_39.jpg", "MLS_40.jpg", "MLS_41.jpg", "MLS_42.jpg", "MLS_43.jpg", "MLS_44.jpg"],
      },
      {
        id: "57Alice",
        title: "57 Alice St Unit C, Arcadia, CA",
        price: "998000",
        sold: true,
        soldDate: "2023-04-21",
        soldPrice: "950000",
        bedroom: "3",
        bathroom: "3",
        livingArea: "1736",
        lotSize: "",
        yearBuild: "",
        thumb: true,
        pics: ["MLS_1.jpg", "MLS_2.jpg", "MLS_3.jpg", "MLS_4.jpg", "MLS_5.jpg", "MLS_6.jpg", "MLS_7.jpg", "MLS_8.jpg", "MLS_9.jpg", "MLS_10.jpg", "MLS_11.jpg", "MLS_12.jpg", "MLS_13.jpg", "MLS_14.jpg", "MLS_15.jpg", "MLS_16.jpg", "MLS_17.jpg", "MLS_18.jpg", "MLS_19.jpg", "MLS_2.jpg", "MLS_20.jpg", "MLS_21.jpg", "MLS_22.jpg", "MLS_23.jpg", "MLS_24.jpg", "MLS_25.jpg", "MLS_26.jpg", "MLS_27.jpg", "MLS_28.jpg", "MLS_29.jpg", "MLS_30.jpg", "MLS_31.jpg", "MLS_32.jpg", "MLS_33.jpg", "MLS_34.jpg", "MLS_35.jpg", "MLS_36.jpg", "MLS_37.jpg"],
      },
      {
        id: "2620Whitney",
        title: "2620 Whitney Dr, Alhambra, CA",
        price: "748000",
        sold: true,
        soldDate: "2023-03-28",
        soldPrice: "770000",
        bedroom: "2",
        bathroom: "2",
        livingArea: "923",
        lotSize: "6288",
        yearBuild: "",
        thumb: true,
        pics: ["MLS_1.jpg", "MLS_2.jpg", "MLS_3.jpg", "MLS_4.jpg", "MLS_5.jpg", "MLS_6.jpg", "MLS_7.jpg", "MLS_8.jpg", "MLS_9.jpg", "MLS_10.jpg", "MLS_11.jpg", "MLS_12.jpg", "MLS_13.jpg", "MLS_14.jpg", "MLS_15.jpg", "MLS_16.jpg", "MLS_17.jpg", "MLS_18.jpg", "MLS_19.jpg", "MLS_20.jpg", "MLS_21.jpg", "MLS_22.jpg", "MLS_23.jpg", "MLS_24.jpg", "MLS_25.jpg", "MLS_26.jpg", "MLS_27.jpg", "MLS_28.jpg", "MLS_29.jpg", "MLS_30.jpg", "MLS_31.jpg", "MLS_32.jpg", "MLS_33.jpg", "MLS_34.jpg", "MLS_35.jpg", "MLS_36.jpg", "MLS_37.jpg", "MLS_38.jpg"],
      },
      {
        id: "1231Lafayette",
        title: "1231 LAFAYETTE ST",
        price: "1480000",
        sold: true,
        soldDate: "2022-11-04",
        soldPrice: "1342362",
        bedroom: "5",
        bathroom: "4.5",
        livingArea: "2802",
        lotSize: "7787",
        yearBuild: "2002",
        thumb: true,
        pics: [
          "MLS_1.jpg",
          "MLS_10.jpg",
          "MLS_11.jpg",
          "MLS_12.jpg",
          "MLS_13.jpg",
          "MLS_14.jpg",
          "MLS_15.jpg",
          "MLS_16.jpg",
          "MLS_17.jpg",
          "MLS_18.jpg",
          "MLS_19.jpg",
          "MLS_2.jpg",
          "MLS_20.jpg",
          "MLS_21.jpg",
          "MLS_22.jpg",
          "MLS_23.jpg",
          "MLS_24.jpg",
          "MLS_25.jpg",
          "MLS_26.jpg",
          "MLS_27.jpg",
          "MLS_28.jpg",
          "MLS_29.jpg",
          "MLS_3.jpg",
          "MLS_30.jpg",
          "MLS_31.jpg",
          "MLS_32.jpg",
          "MLS_33.jpg",
          "MLS_34.jpg",
          "MLS_35.jpg",
          "MLS_36.jpg",
          "MLS_37.jpg",
          "MLS_38.jpg",
          "MLS_39.jpg",
          "MLS_4.jpg",
          "MLS_40.jpg",
          "MLS_41.jpg",
          "MLS_42.jpg",
          "MLS_43.jpg",
          "MLS_44.jpg",
          "MLS_45.jpg",
          "MLS_46.jpg",
          "MLS_47.jpg",
          "MLS_48.jpg",
          "MLS_49.jpg",
          "MLS_5.jpg",
          "MLS_50.jpg",
          "MLS_51.jpg",
          "MLS_52.jpg",
          "MLS_53.jpg",
          "MLS_54.jpg",
          "MLS_55.jpg",
          "MLS_56.jpg",
          "MLS_57.jpg",
          "MLS_58.jpg",
          "MLS_59.jpg",
          "MLS_6.jpg",
          "MLS_60.jpg",
          "MLS_61.jpg",
          "MLS_62.jpg",
          "MLS_63.jpg",
          "MLS_64.jpg",
          "MLS_65.jpg",
          "MLS_66.jpg",
          "MLS_67.jpg",
          "MLS_68.jpg",
          "MLS_7.jpg",
          "MLS_8.jpg",
          "MLS_9.jpg",
        ],
      },
      {
        id: "17024COLIMA85",
        title: "17024 COLIMA RD #85",
        price: "399000",
        sold: true,
        soldDate: "2022-10-28",
        soldPrice: "430000",
        bedroom: "2",
        bathroom: "1",
        livingArea: "",
        lotSize: "",
        yearBuild: "",
        thumb: true,
        pics: ["MLS_1.jpg", "MLS_10.jpg", "MLS_11.jpg", "MLS_12.jpg", "MLS_13.jpg", "MLS_14.jpg", "MLS_15.jpg", "MLS_16.jpg", "MLS_17.jpg", "MLS_18.jpg", "MLS_19.jpg", "MLS_2.jpg", "MLS_20.jpg", "MLS_21.jpg", "MLS_22.jpg", "MLS_23.jpg", "MLS_24.jpg", "MLS_25.jpg", "MLS_26.jpg", "MLS_27.jpg", "MLS_28.jpg", "MLS_29.jpg", "MLS_3.jpg", "MLS_30.jpg", "MLS_31.jpg", "MLS_32.jpg", "MLS_4.jpg", "MLS_5.jpg", "MLS_6.jpg", "MLS_7.jpg", "MLS_8.jpg", "MLS_9.jpg"],
      },
      {
        id: "8581EVillage",
        title: "8581 Village Ln",
        price: "538000",
        sold: true,
        soldDate: "2022-08-17",
        soldPrice: "550000",
        bedroom: "2",
        bathroom: "2",
        livingArea: "1172",
        lotSize: "1169",
        yearBuild: "",
        thumb: true,
        pics: ["MLS_1.jpg", "MLS_2.jpg", "MLS_3.jpg", "MLS_4.jpg", "MLS_5.jpg", "MLS_6.jpg", "MLS_7.jpg", "MLS_8.jpg", "MLS_9.jpg", "MLS_10.jpg", "MLS_11.jpg", "MLS_12.jpg", "MLS_13.jpg", "MLS_14.jpg", "MLS_15.jpg", "MLS_16.jpg", "MLS_17.jpg", "MLS_18.jpg", "MLS_19.jpg", "MLS_20.jpg", "MLS_21.jpg", "MLS_22.jpg", "MLS_23.jpg", "MLS_24.jpg", "MLS_25.jpg", "MLS_26.jpg", "MLS_27.jpg", "MLS_28.jpg", "MLS_29.jpg"],
      },
      {
        id: "809NHidalgo",
        title: "809 N Hidalgo Ave",
        price: "1298000",
        sold: true,
        soldDate: "2022-08-16",
        soldPrice: "1300000",
        bedroom: "3",
        bathroom: "2",
        livingArea: "1748",
        lotSize: "8601",
        yearBuild: "",
        thumb: true,
        pics: ["MLS_1.jpg", "MLS_10.jpg", "MLS_11.jpg", "MLS_12.jpg", "MLS_13.jpg", "MLS_14.jpg", "MLS_15.jpg", "MLS_16.jpg", "MLS_17.jpg", "MLS_18.jpg", "MLS_19.jpg", "MLS_2.jpg", "MLS_20.jpg", "MLS_21.jpg", "MLS_22.jpg", "MLS_23.jpg", "MLS_24.jpg", "MLS_25.jpg", "MLS_26.jpg", "MLS_27.jpg", "MLS_28.jpg", "MLS_29.jpg", "MLS_3.jpg", "MLS_30.jpg", "MLS_31.jpg", "MLS_32.jpg", "MLS_33.jpg", "MLS_34.jpg", "MLS_35.jpg", "MLS_36.jpg", "MLS_37.jpg", "MLS_38.jpg", "MLS_39.jpg", "MLS_4.jpg", "MLS_40.jpg", "MLS_41.jpg", "MLS_42.jpg", "MLS_43.jpg", "MLS_44.jpg", "MLS_45.jpg", "MLS_46.jpg", "MLS_47.jpg", "MLS_48.jpg", "MLS_49.jpg", "MLS_5.jpg", "MLS_50.jpg", "MLS_51.jpg", "MLS_52.jpg", "MLS_53.jpg", "MLS_54.jpg", "MLS_6.jpg", "MLS_7.jpg", "MLS_8.jpg", "MLS_9.jpg"],
      },
      {
        id: "425WWoodward",
        title: "425 W Woodward Ave",
        price: "798000",
        sold: true,
        soldDate: "2022-08-12",
        soldPrice: "798000",
        bedroom: "3",
        bathroom: "2",
        livingArea: "1492",
        lotSize: "5488",
        yearBuild: "",
        thumb: true,
        pics: ["MLS_5.jpg", "MLS_2.jpg", "MLS_3.jpg", "MLS_4.jpg", "MLS_1.jpg", "MLS_6.jpg", "MLS_7.jpg", "MLS_8.jpg", "MLS_9.jpg", "MLS_10.jpg", "MLS_11.jpg", "MLS_12.jpg", "MLS_13.jpg", "MLS_14.jpg", "MLS_15.jpg", "MLS_16.jpg", "MLS_17.jpg", "MLS_18.jpg", "MLS_19.jpg", "MLS_2.jpg", "MLS_20.jpg", "MLS_21.jpg", "MLS_22.jpg", "MLS_23.jpg", "MLS_24.jpg", "MLS_25.jpg", "MLS_26.jpg", "MLS_27.jpg", "MLS_28.jpg", "MLS_29.jpg", "MLS_30.jpg", "MLS_31.jpg", "MLS_32.jpg", "MLS_33.jpg", "MLS_34.jpg", "MLS_35.jpg", "MLS_36.jpg", "MLS_37.jpg", "MLS_38.jpg", "MLS_39.jpg", "MLS_40.jpg", "MLS_41.jpg", "MLS_42.jpg", "MLS_43.jpg", "MLS_44.jpg", "MLS_45.jpg"],
      },
      {
        id: "7319Mooney",
        title: "7319 Mooney Drive, Rosemead, CA 91770",
        price: "698000",
        sold: true,
        soldDate: "",
        soldPrice: "",
        bedroom: "3",
        bathroom: "3",
        livingArea: "1204",
        lotSize: "12839",
        yearBuild: "1934",
        thumb: true,
        pics: ["MLS_1.jpg", "MLS_10.jpg", "MLS_11.jpg", "MLS_12.jpg", "MLS_13.jpg", "MLS_14.jpg", "MLS_15.jpg", "MLS_16.jpg", "MLS_17.jpg", "MLS_18.jpg", "MLS_19.jpg", "MLS_2.jpg", "MLS_20.jpg", "MLS_21.jpg", "MLS_22.jpg", "MLS_23.jpg", "MLS_24.jpg", "MLS_25.jpg", "MLS_26.jpg", "MLS_27.jpg", "MLS_28.jpg", "MLS_29.jpg", "MLS_3.jpg", "MLS_30.jpg", "MLS_31.jpg", "MLS_32.jpg", "MLS_33.jpg", "MLS_34.jpg", "MLS_35.jpg", "MLS_36.jpg", "MLS_37.jpg", "MLS_38.jpg", "MLS_39.jpg", "MLS_4.jpg", "MLS_40.jpg", "MLS_41.jpg", "MLS_42.jpg", "MLS_5.jpg", "MLS_6.jpg", "MLS_7.jpg", "MLS_8.jpg", "MLS_9.jpg"],
      },
      {
        id: "620TheVillage",
        sold: true,
        title: "620 The Village, #312, Redondo Beach, CA 90277",
        soldDate: "2022-08-02",
        soldPrice: "800000",
        bedroom: "1",
        bathroom: "1",
        livingArea: "619",
        lotSize: "",
        yearBuild: "1974",
        pics: ["620TheVillage1.jpg", "620TheVillage2.jpg", "620TheVillage3.jpg", "620TheVillage4.jpg", "620TheVillage5.jpg"],
      },
      {
        id: "304Palmetto",
        title: "304 Palmetto Dr #A",
        price: "738000",
        sold: true,
        soldDate: "2022-07-14",
        soldPrice: "818000",
        bedroom: "3",
        bathroom: "3",
        livingArea: "1551",
        lotSize: "0.52",
        yearBuild: "",
        thumb: true,
        pics: ["MLS_1.jpg", "MLS_10.jpg", "MLS_11.jpg", "MLS_12.jpg", "MLS_13.jpg", "MLS_14.jpg", "MLS_15.jpg", "MLS_16.jpg", "MLS_17.jpg", "MLS_18.jpg", "MLS_19.jpg", "MLS_2.jpg", "MLS_20.jpg", "MLS_21.jpg", "MLS_22.jpg", "MLS_23.jpg", "MLS_24.jpg", "MLS_25.jpg", "MLS_26.jpg", "MLS_27.jpg", "MLS_28.jpg", "MLS_29.jpg", "MLS_3.jpg", "MLS_30.jpg", "MLS_31.jpg", "MLS_32.jpg", "MLS_33.jpg", "MLS_34.jpg", "MLS_35.jpg", "MLS_36.jpg", "MLS_37.jpg", "MLS_38.jpg", "MLS_39.jpg", "MLS_4.jpg", "MLS_40.jpg", "MLS_5.jpg", "MLS_6.jpg", "MLS_7.jpg", "MLS_8.jpg", "MLS_9.jpg"],
      },
      {
        id: "725Plymouth2",
        title: "725 Plymouth Rd, San Marino, CA",
        price: "2888000",
        sold: true,
        soldDate: "2022-06-03",
        soldPrice: "2860000",
        bedroom: "4",
        bathroom: "3",
        livingArea: "2943",
        lotSize: "6777",
        yearBuild: "",
        thumb: true,
        // preview: ['MLS_1.jpg', 'MLS_9.jpg','MLS_10.jpg','MLS_15.jpg','MLS_18.jpg','MLS_19.jpg','MLS_20.jpg','MLS_27.jpg','MLS_32.jpg','MLS_39.jpg'],
        pics: ["MLS_1.jpg", "MLS_2.jpg", "MLS_3.jpg", "MLS_4.jpg", "MLS_5.jpg", "MLS_6.jpg", "MLS_7.jpg", "MLS_8.jpg", "MLS_9.jpg", "MLS_10.jpg", "MLS_11.jpg", "MLS_12.jpg", "MLS_13.jpg", "MLS_14.jpg", "MLS_15.jpg", "MLS_16.jpg", "MLS_17.jpg", "MLS_18.jpg", "MLS_19.jpg", "MLS_20.jpg", "MLS_21.jpg", "MLS_22.jpg", "MLS_23.jpg", "MLS_24.jpg", "MLS_25.jpg", "MLS_26.jpg", "MLS_27.jpg", "MLS_28.jpg", "MLS_29.jpg", "MLS_30.jpg", "MLS_31.jpg", "MLS_32.jpg", "MLS_33.jpg", "MLS_34.jpg", "MLS_35.jpg", "MLS_36.jpg", "MLS_37.jpg", "MLS_38.jpg", "MLS_39.jpg", "MLS_40.jpg", "MLS_41.jpg", "MLS_42.jpg", "MLS_43.jpg", "MLS_44.jpg", "MLS_45.jpg", "MLS_46.jpg", "MLS_47.jpg", "MLS_48.jpg", "MLS_49.jpg", "MLS_50.jpg", "MLS_51.jpg"],
      },
      {
        id: "200EBay",
        title: "200 E Bay State St APT D",
        price: "698000",
        sold: true,
        soldDate: "2022-05-23",
        soldPrice: "800000",
        bedroom: "3",
        bathroom: "2.5",
        livingArea: "1295",
        lotSize: "",
        yearBuild: "",
        thumb: true,
        pics: ["MLS_1.jpg", "MLS_10.jpg", "MLS_11.jpg", "MLS_12.jpg", "MLS_13.jpg", "MLS_14.jpg", "MLS_15.jpg", "MLS_16.jpg", "MLS_17.jpg", "MLS_18.jpg", "MLS_19.jpg", "MLS_2.jpg", "MLS_20.jpg", "MLS_21.jpg", "MLS_22.jpg", "MLS_23.jpg", "MLS_24.jpg", "MLS_25.jpg", "MLS_26.jpg", "MLS_27.jpg", "MLS_28.jpg", "MLS_29.jpg", "MLS_3.jpg", "MLS_30.jpg", "MLS_31.jpg", "MLS_32.jpg", "MLS_33.jpg", "MLS_34.jpg", "MLS_35.jpg", "MLS_36.jpg", "MLS_37.jpg", "MLS_38.jpg", "MLS_39.jpg", "MLS_4.jpg", "MLS_40.jpg", "MLS_41.jpg", "MLS_42.jpg", "MLS_43.jpg", "MLS_44.jpg", "MLS_45.jpg", "MLS_5.jpg", "MLS_6.jpg", "MLS_7.jpg", "MLS_8.jpg", "MLS_9.jpg"],
      },
      {
        id: "482SArroyo305",
        title: "482 S Arroyo Pkwy Ste 305, Pasadena, CA",
        price: "658000",
        sold: true,
        soldDate: "2022-02-10",
        soldPrice: "729999",
        bedroom: "1",
        bathroom: "1",
        livingArea: "750",
        lotSize: "",
        yearBuild: "",
        thumb: true,
        pics: ["MLS_1.jpg", "MLS_10.jpg", "MLS_11.jpg", "MLS_12.jpg", "MLS_13.jpg", "MLS_14.jpg", "MLS_15.jpg", "MLS_16.jpg", "MLS_17.jpg", "MLS_18.jpg", "MLS_19.jpg", "MLS_2.jpg", "MLS_20.jpg", "MLS_21.jpg", "MLS_22.jpg", "MLS_23.jpg", "MLS_24.jpg", "MLS_25.jpg", "MLS_26.jpg", "MLS_27.jpg", "MLS_28.jpg", "MLS_29.jpg", "MLS_3.jpg", "MLS_30.jpg", "MLS_31.jpg", "MLS_32.jpg", "MLS_33.jpg", "MLS_34.jpg", "MLS_35.jpg", "MLS_36.jpg", "MLS_37.jpg", "MLS_38.jpg", "MLS_39.jpg", "MLS_4.jpg", "MLS_40.jpg", "MLS_41.jpg", "MLS_42.jpg", "MLS_5.jpg", "MLS_6.jpg", "MLS_7.jpg", "MLS_8.jpg", "MLS_9.jpg"],
      },
      {
        id: "738SChapel11",
        title: "738 S Chapel Ave Apt 11, Alhambra, CA",
        price: "488000",
        sold: true,
        soldDate: "2022-02-11",
        soldPrice: "550000",
        bedroom: "2",
        bathroom: "1",
        livingArea: "918",
        lotSize: "",
        yearBuild: "",
        thumb: true,
        pics: ["MLS_1.jpg", "MLS_10.jpg", "MLS_11.jpg", "MLS_12.jpg", "MLS_13.jpg", "MLS_14.jpg", "MLS_15.jpg", "MLS_16.jpg", "MLS_17.jpg", "MLS_18.jpg", "MLS_19.jpg", "MLS_2.jpg", "MLS_20.jpg", "MLS_21.jpg", "MLS_22.jpg", "MLS_23.jpg", "MLS_3.jpg", "MLS_4.jpg", "MLS_5.jpg", "MLS_6.jpg", "MLS_7.jpg", "MLS_8.jpg", "MLS_9.jpg"],
      },
      {
        id: "1827Vine",
        title: "1827 Vine St #B, Alhambra, CA 91801",
        price: "598000",
        sold: true,
        soldDate: "2022-01-20",
        soldPrice: "678000",
        bedroom: "2",
        bathroom: "2.5",
        livingArea: "1165",
        lotSize: "",
        yearBuild: "",
        thumb: true,
        pics: ["MLS_1.jpg", "MLS_10.jpg", "MLS_11.jpg", "MLS_12.jpg", "MLS_13.jpg", "MLS_14.jpg", "MLS_15.jpg", "MLS_16.jpg", "MLS_17.jpg", "MLS_18.jpg", "MLS_19.jpg", "MLS_2.jpg", "MLS_20.jpg", "MLS_21.jpg", "MLS_22.jpg", "MLS_23.jpg", "MLS_3.jpg", "MLS_4.jpg", "MLS_5.jpg", "MLS_6.jpg", "MLS_7.jpg", "MLS_8.jpg", "MLS_9.jpg"],
      },
      {
        id: "305SChapel",
        title: "305 S Chapel Ave Unit B, Alhambra, CA 91801",
        price: "668000",
        sold: true,
        soldDate: "2022-01-07",
        soldPrice: "720000",
        bedroom: "3",
        bathroom: "3",
        livingArea: "1450",
        lotSize: "",
        yearBuild: "1988",
        thumb: true,
        pics: ["MLS_1.jpg", "MLS_10.jpg", "MLS_11.jpg", "MLS_12.jpg", "MLS_13.jpg", "MLS_14.jpg", "MLS_15.jpg", "MLS_16.jpg", "MLS_17.jpg", "MLS_18.jpg", "MLS_19.jpg", "MLS_2.jpg", "MLS_20.jpg", "MLS_21.jpg", "MLS_22.jpg", "MLS_23.jpg", "MLS_24.jpg", "MLS_25.jpg", "MLS_26.jpg", "MLS_27.jpg", "MLS_28.jpg", "MLS_29.jpg", "MLS_3.jpg", "MLS_30.jpg", "MLS_31.jpg", "MLS_32.jpg", "MLS_33.jpg", "MLS_34.jpg", "MLS_35.jpg", "MLS_4.jpg", "MLS_5.jpg", "MLS_6.jpg", "MLS_7.jpg", "MLS_8.jpg", "MLS_9.jpg"],
      },
      {
        id: "303EFoothill",
        title: "303 E Foothill Blvd, Arcadia, CA 91006",
        price: "998000",
        sold: true,
        soldDate: "2021-12-08",
        soldPrice: "980000",
        bedroom: "4",
        bathroom: "3",
        livingArea: "1516",
        lotSize: "9501",
        yearBuild: "1953",
        thumb: true,
        pics: ["MLS_1.jpg", "MLS_10.jpg", "MLS_11.jpg", "MLS_12.jpg", "MLS_13.jpg", "MLS_14.jpg", "MLS_15.jpg", "MLS_16.jpg", "MLS_17.jpg", "MLS_18.jpg", "MLS_19.jpg", "MLS_2.jpg", "MLS_20.jpg", "MLS_21.jpg", "MLS_22.jpg", "MLS_23.jpg", "MLS_24.jpg", "MLS_25.jpg", "MLS_26.jpg", "MLS_27.jpg", "MLS_28.jpg", "MLS_29.jpg", "MLS_3.jpg", "MLS_30.jpg", "MLS_31.jpg", "MLS_32.jpg", "MLS_33.jpg", "MLS_34.jpg", "MLS_35.jpg", "MLS_36.jpg", "MLS_37.jpg", "MLS_38.jpg", "MLS_39.jpg", "MLS_4.jpg", "MLS_40.jpg", "MLS_41.jpg", "MLS_42.jpg", "MLS_43.jpg", "MLS_44.jpg", "MLS_45.jpg", "MLS_5.jpg", "MLS_6.jpg", "MLS_7.jpg", "MLS_8.jpg", "MLS_9.jpg"],
      },
      {
        id: "13041Jardene",
        title: "13041 Jardene St, Corona, CA 92880",
        price: "798000",
        sold: true,
        soldDate: "2021-11-23",
        soldPrice: "810000",
        bedroom: "4",
        bathroom: "3",
        livingArea: "2900",
        lotSize: "6534",
        yearBuild: "2005",
        thumb: true,
        // preview:['MLS_5.jpg','MLS_11.jpg','MLS_8.jpg','MLS_13.jpg','MLS_16.jpg','MLS_20.jpg','MLS_26.jpg','MLS_30.jpg'],
        pics: [
          "MLS_1.jpg",
          "MLS_2.jpg",
          "MLS_3.jpg",
          "MLS_4.jpg",
          "MLS_5.jpg",
          "MLS_6.jpg",
          "MLS_7.jpg",
          "MLS_8.jpg",
          "MLS_9.jpg",
          "MLS_10.jpg",
          "MLS_11.jpg",
          "MLS_12.jpg",
          "MLS_13.jpg",
          "MLS_14.jpg",
          "MLS_15.jpg",
          "MLS_16.jpg",
          "MLS_17.jpg",
          "MLS_18.jpg",
          "MLS_19.jpg",
          "MLS_20.jpg",
          "MLS_21.jpg",
          "MLS_22.jpg",
          "MLS_23.jpg",
          "MLS_24.jpg",
          "MLS_25.jpg",
          "MLS_26.jpg",
          "MLS_27.jpg",
          "MLS_28.jpg",
          "MLS_29.jpg",
          "MLS_30.jpg",
          "MLS_31.jpg",
          "MLS_32.jpg",
          "MLS_33.jpg",
          "MLS_34.jpg",
          "MLS_35.jpg",
          "MLS_36.jpg",
          "MLS_37.jpg",
          "MLS_38.jpg",
          "MLS_39.jpg",
          "MLS_4.jpg",
          "MLS_40.jpg",
          "MLS_41.jpg",
          "MLS_42.jpg",
          "MLS_43.jpg",
          "MLS_44.jpg",
          "MLS_45.jpg",
          "MLS_46.jpg",
          "MLS_47.jpg",
          "MLS_48.jpg",
          "MLS_49.jpg",
          "MLS_5.jpg",
          "MLS_50.jpg",
          "MLS_51.jpg",
          "MLS_52.jpg",
          "MLS_53.jpg",
          "MLS_54.jpg",
          "MLS_55.jpg",
        ],
      },
      {
        id: "318olive",
        title: "318 N Olive Ave, Alhambra, CA 91801",
        price: "938000",
        sold: true,
        soldDate: "2021-10-27",
        soldPrice: "938000",
        bedroom: "4",
        bathroom: "2",
        livingArea: "1510",
        lotSize: "8300",
        yearBuild: "1940",
        thumb: true,
        pics: ["MLS_1.jpg", "MLS_10.jpg", "MLS_11.jpg", "MLS_12.jpg", "MLS_13.jpg", "MLS_14.jpg", "MLS_15.jpg", "MLS_16.jpg", "MLS_17.jpg", "MLS_18.jpg", "MLS_19.jpg", "MLS_2.jpg", "MLS_20.jpg", "MLS_21.jpg", "MLS_22.jpg", "MLS_23.jpg", "MLS_24.jpg", "MLS_25.jpg", "MLS_26.jpg", "MLS_27.jpg", "MLS_28.jpg", "MLS_29.jpg", "MLS_3.jpg", "MLS_30.jpg", "MLS_31.jpg", "MLS_32.jpg", "MLS_33.jpg", "MLS_34.jpg", "MLS_35.jpg", "MLS_36.jpg", "MLS_37.jpg", "MLS_38.jpg", "MLS_39.jpg", "MLS_4.jpg", "MLS_40.jpg", "MLS_41.jpg", "MLS_42.jpg", "MLS_43.jpg", "MLS_44.jpg", "MLS_45.jpg", "MLS_46.jpg", "MLS_47.jpg", "MLS_48.jpg", "MLS_49.jpg", "MLS_5.jpg", "MLS_50.jpg", "MLS_51.jpg", "MLS_52.jpg", "MLS_53.jpg", "MLS_6.jpg", "MLS_7.jpg", "MLS_8.jpg", "MLS_9.jpg"],
      },
      {
        id: "1000ross",
        title: "1000 E Ross Ave, Alhambra, CA 91801",
        price: "768000",
        sold: true,
        soldDate: "2021-10-26",
        soldPrice: "768000",
        bedroom: "3",
        bathroom: "2",
        livingArea: "1257",
        lotSize: "7167",
        yearBuild: "1947",
        thumb: true,
        pics: ["MLS_1.jpg", "MLS_10.jpg", "MLS_11.jpg", "MLS_12.jpg", "MLS_13.jpg", "MLS_14.jpg", "MLS_15.jpg", "MLS_16.jpg", "MLS_17.jpg", "MLS_18.jpg", "MLS_19.jpg", "MLS_2.jpg", "MLS_20.jpg", "MLS_21.jpg", "MLS_22.jpg", "MLS_23.jpg", "MLS_24.jpg", "MLS_25.jpg", "MLS_26.jpg", "MLS_27.jpg", "MLS_28.jpg", "MLS_29.jpg", "MLS_3.jpg", "MLS_30.jpg", "MLS_31.jpg", "MLS_32.jpg", "MLS_33.jpg", "MLS_34.jpg", "MLS_35.jpg", "MLS_36.jpg", "MLS_37.jpg", "MLS_38.jpg", "MLS_39.jpg", "MLS_4.jpg", "MLS_40.jpg", "MLS_41.jpg", "MLS_42.jpg", "MLS_43.jpg", "MLS_44.jpg", "MLS_45.jpg", "MLS_5.jpg", "MLS_6.jpg", "MLS_7.jpg", "MLS_8.jpg", "MLS_9.jpg"],
      },
      {
        id: "517NAlhambra",
        title: "517 N Alhambra Ave #B, Monterey Park, CA 91755",
        price: "658000",
        sold: true,
        soldDate: "2021-10-14",
        soldPrice: "698000",
        bedroom: "4",
        bathroom: "3",
        livingArea: "1487",
        lotSize: "",
        yearBuild: "1985",
        thumb: true,
        pics: ["MLS_1.jpg", "MLS_10-1-900x600.jpg", "MLS_11-1-900x600.jpg", "MLS_12-1-900x600.jpg", "MLS_13-1-900x600.jpg", "MLS_15-1-900x600.jpg", "MLS_16-1-900x600.jpg", "MLS_18-1-900x600.jpg", "MLS_21-1-900x600.jpg", "MLS_23-1-900x600.jpg", "MLS_25-1-900x600.jpg", "MLS_26-1-900x600.jpg", "MLS_27-1-900x600.jpg", "MLS_28-1-900x600.jpg", "MLS_29-1-900x600.jpg", "MLS_34-1-900x600.jpg", "MLS_5-1-900x600.jpg", "MLS_9-1-900x600.jpg"],
      },
      {
        id: "1417marguerita",
        title: "1417 S Marguerita Ave APT 10, Alhambra, CA 91803",
        price: "588000",
        sold: true,
        soldDate: "2021-10-13",
        soldPrice: "610000",
        bedroom: "3",
        bathroom: "3",
        livingArea: "1286",
        lotSize: "",
        yearBuild: "1982",
        thumb: true,
        pics: ["MLS_1.jpg", "MLS_10.jpg", "MLS_11.jpg", "MLS_12.jpg", "MLS_13.jpg", "MLS_14.jpg", "MLS_15.jpg", "MLS_16.jpg", "MLS_17.jpg", "MLS_18.jpg", "MLS_19.jpg", "MLS_2.jpg", "MLS_20.jpg", "MLS_21.jpg", "MLS_22.jpg", "MLS_23.jpg", "MLS_24.jpg", "MLS_3.jpg", "MLS_4.jpg", "MLS_5.jpg"],
      },
      {
        id: "375GrandM",
        title: "375 Grand Ave, Monrovia, CA 91016",
        price: "988000",
        sold: true,
        soldDate: "2021-09-29",
        soldPrice: "1060000",
        bedroom: "3",
        bathroom: "3",
        livingArea: "1632",
        lotSize: "7482",
        yearBuild: "1957",
        thumb: true,
        pics: ["MLS_1.jpg", "MLS_10.jpg", "MLS_11.jpg", "MLS_12.jpg", "MLS_13.jpg", "MLS_14.jpg", "MLS_15.jpg", "MLS_16.jpg", "MLS_17.jpg", "MLS_18.jpg", "MLS_19.jpg", "MLS_2.jpg", "MLS_20.jpg", "MLS_21.jpg", "MLS_22.jpg", "MLS_23.jpg", "MLS_24.jpg", "MLS_25.jpg", "MLS_26.jpg", "MLS_27.jpg", "MLS_28.jpg", "MLS_29.jpg", "MLS_3.jpg", "MLS_30.jpg", "MLS_31.jpg", "MLS_32.jpg", "MLS_33.jpg", "MLS_34.jpg", "MLS_35.jpg", "MLS_36.jpg", "MLS_37.jpg", "MLS_38.jpg", "MLS_39.jpg", "MLS_4.jpg", "MLS_40.jpg", "MLS_41.jpg", "MLS_42.jpg", "MLS_43.jpg", "MLS_44.jpg", "MLS_45.jpg", "MLS_46.jpg", "MLS_5.jpg", "MLS_6.jpg", "MLS_7.jpg", "MLS_8.jpg", "MLS_9.jpg"],
      },
      {
        id: "320olive",
        title: "320 N Olive Ave, Alhambra, CA 91801",
        price: "1280000",
        sold: true,
        soldDate: "2021-08-02",
        soldPrice: "1365000",
        bedroom: "7",
        bathroom: "5",
        livingArea: "3125",
        lotSize: "8311",
        yearBuild: "1953",
        thumb: true,
        pics: ["MLS_2.jpg", "MLS_5.jpg", "MLS_8.jpg", "MLS_10.jpg", "MLS_11.jpg", "MLS_12.jpg", "MLS_17.jpg", "MLS_23.jpg", "MLS_27.jpg", "MLS_1-1.jpg", "MLS_2-1.jpg", "MLS_3-1.jpg"],
      },
      {
        id: "1250Mayflower",
        title: "1250 Mayflower Ave",
        price: "1088000",
        sold: true,
        soldDate: "2021-07-30",
        soldPrice: "1238888",
        bedroom: "3",
        bathroom: "3",
        livingArea: "1939",
        lotSize: "15225",
        yearBuild: "1946",
        thumb: true,
        // preview:['MLS_1.jpg','MLS_4.jpg','MLS_6.jpg','MLS_9.jpg','MLS_11.jpg','MLS_15.jpg','MLS_19.jpg','MLS_26.jpg','MLS_28.jpg','MLS_30.jpg','MLS_34.jpg','MLS_36.jpg'],
        pics: ["MLS_1.jpg", "MLS_2.jpg", "MLS_3.jpg", "MLS_4.jpg", "MLS_5.jpg", "MLS_6.jpg", "MLS_7.jpg", "MLS_8.jpg", "MLS_9.jpg", "MLS_10.jpg", "MLS_11.jpg", "MLS_12.jpg", "MLS_13.jpg", "MLS_14.jpg", "MLS_15.jpg", "MLS_16.jpg", "MLS_17.jpg", "MLS_18.jpg", "MLS_19.jpg", "MLS_20.jpg", "MLS_21.jpg", "MLS_22.jpg", "MLS_23.jpg", "MLS_24.jpg", "MLS_25.jpg", "MLS_26.jpg", "MLS_27.jpg", "MLS_28.jpg", "MLS_29.jpg", "MLS_30.jpg", "MLS_31.jpg", "MLS_32.jpg", "MLS_33.jpg", "MLS_34.jpg", "MLS_35.jpg", "MLS_36.jpg", "MLS_37.jpg", "MLS_38.jpg", "MLS_39.jpg", "MLS_4.jpg", "MLS_40.jpg", "MLS_41.jpg", "MLS_42.jpg", "MLS_43.jpg", "MLS_44.jpg", "MLS_45.jpg", "MLS_46.jpg", "MLS_47.jpg", "MLS_48.jpg", "MLS_49.jpg", "MLS_50.jpg", "MLS_51.jpg"],
      },
      {
        id: "545LaPazDr",
        title: "545 La Paz Dr, San Marino, CA 91108",
        price: "2180000",
        sold: true,
        soldDate: "2021-04-07",
        soldPrice: "2180000",
        bedroom: "3",
        bathroom: "3",
        livingArea: "2732",
        lotSize: "8102",
        yearBuild: "1927",
        thumb: true,
        // preview:['MLS_1.jpg','MLS_12.jpg','MLS_13.jpg','MLS_19.jpg','MLS_22.jpg','MLS_29.jpg','MLS_45.jpg','MLS_48.jpg'],
        pics: ["MLS_1.jpg", "MLS_10.jpg", "MLS_11.jpg", "MLS_12.jpg", "MLS_13.jpg", "MLS_14.jpg", "MLS_15.jpg", "MLS_16.jpg", "MLS_17.jpg", "MLS_18.jpg", "MLS_19.jpg", "MLS_2.jpg", "MLS_20.jpg", "MLS_21.jpg", "MLS_22.jpg", "MLS_23.jpg", "MLS_24.jpg", "MLS_25.jpg", "MLS_26.jpg", "MLS_27.jpg", "MLS_28.jpg", "MLS_29.jpg", "MLS_3.jpg", "MLS_30.jpg", "MLS_31.jpg", "MLS_32.jpg", "MLS_33.jpg", "MLS_34.jpg", "MLS_35.jpg", "MLS_36.jpg", "MLS_37.jpg", "MLS_38.jpg", "MLS_39.jpg", "MLS_4.jpg", "MLS_40.jpg", "MLS_41.jpg", "MLS_42.jpg", "MLS_43.jpg", "MLS_44.jpg", "MLS_45.jpg", "MLS_46.jpg", "MLS_47.jpg", "MLS_48.jpg", "MLS_49.jpg", "MLS_5.jpg", "MLS_50.jpg", "MLS_51.jpg", "MLS_52.jpg", "MLS_53.jpg", "MLS_54.jpg", "MLS_6.jpg", "MLS_7.jpg", "MLS_8.jpg", "MLS_9.jpg"],
      },
      {
        id: "1909Leman",
        title: "1909 Leman St, South Pasadena, CA 91030",
        price: "1098000",
        sold: true,
        soldDate: "2021-05-12",
        soldPrice: "1270000",
        bedroom: "3",
        bathroom: "3",
        livingArea: "1686",
        lotSize: "",
        yearBuild: "2008",
        thumb: true,
        preview: ["MLS_7.jpg", "MLS_3.jpg", "MLS_1.jpg"],
        pics: ["MLS_1.jpg", "MLS_2.jpg", "MLS_3.jpg", "MLS_4.jpg", "MLS_5.jpg", "MLS_6.jpg", "MLS_7.jpg"],
      },
      {
        id: "1160SGoldenWest",
        title: "1160 S Golden West Ave #2, Arcadia, CA 91007",
        price: "688000",
        sold: true,
        soldDate: "2021-09-08",
        soldPrice: "650000",
        bedroom: "3",
        bathroom: "3",
        livingArea: "1444",
        lotSize: "",
        yearBuild: "1975",
        thumb: true,
        pics: ["MLS_1.jpg", "MLS_10.jpg", "MLS_11.jpg", "MLS_12.jpg", "MLS_13.jpg", "MLS_14.jpg", "MLS_15.jpg", "MLS_16.jpg", "MLS_17.jpg", "MLS_18.jpg", "MLS_19.jpg", "MLS_2.jpg", "MLS_20.jpg", "MLS_21.jpg", "MLS_22.jpg", "MLS_23.jpg", "MLS_24.jpg", "MLS_25.jpg", "MLS_26.jpg", "MLS_27.jpg", "MLS_28.jpg", "MLS_3.jpg", "MLS_4.jpg", "MLS_5.jpg", "MLS_6.jpg", "MLS_7.jpg", "MLS_8.jpg", "MLS_9.jpg"],
      },
      {
        id: "626sixthst",
        title: "626 S 6th St #1, Alhambra, CA 91801",
        price: "508000",
        sold: true,
        soldDate: "2021-05-26",
        soldPrice: "528000",
        bedroom: "3",
        bathroom: "3",
        livingArea: "1185",
        lotSize: "",
        yearBuild: "1983",
        thumb: true,
        // preview:['MLS_1.jpg','MLS_6.jpg','MLS_7.jpg'],
        pics: ["MLS_1.jpg", "MLS_10.jpg", "MLS_11.jpg", "MLS_12.jpg", "MLS_13.jpg", "MLS_14.jpg", "MLS_15.jpg", "MLS_16.jpg", "MLS_17.jpg", "MLS_18.jpg", "MLS_19.jpg", "MLS_2.jpg", "MLS_20.jpg", "MLS_21.jpg", "MLS_22.jpg", "MLS_3.jpg", "MLS_4.jpg", "MLS_5.jpg", "MLS_6.jpg", "MLS_7.jpg", "MLS_8.jpg", "MLS_9.jpg"],
      },
      {
        id: "777EValley",
        title: "777 E Valley Blvd #36, Alhambra, CA 91801",
        price: "538000",
        sold: true,
        soldDate: "2021-04-30",
        soldPrice: "548000",
        bedroom: "2",
        bathroom: "2",
        livingArea: "1147",
        lotSize: "",
        yearBuild: "1963",
        thumb: true,
        preview: ["MLS_1.jpg", "MLS_23.jpg", "MLS_7.jpg", "MLS_21.jpg"],
        pics: ["MLS_1.jpg", "MLS_10.jpg", "MLS_11.jpg", "MLS_12.jpg", "MLS_13.jpg", "MLS_14.jpg", "MLS_15.jpg", "MLS_16.jpg", "MLS_17.jpg", "MLS_18.jpg", "MLS_19.jpg", "MLS_2.jpg", "MLS_20.jpg", "MLS_21.jpg", "MLS_22.jpg", "MLS_23.jpg", "MLS_24.jpg", "MLS_25.jpg", "MLS_26.jpg", "MLS_3.jpg", "MLS_4.jpg", "MLS_5.jpg", "MLS_6.jpg", "MLS_7.jpg", "MLS_8.jpg", "MLS_9.jpg"],
      },

      {
        id: "111Secondst",
        title: "111 N 2nd St #212, Alhambra, CA 91801",
        price: "438000",
        sold: true,
        soldDate: "2021-05-11",
        soldPrice: "438000",
        bedroom: "2",
        bathroom: "2",
        livingArea: "910",
        lotSize: "24411",
        yearBuild: "2009",
        thumb: true,
        pics: ["MLS_1-900x600.jpg", "MLS_10-1-900x600.jpg", "MLS_11-1-900x600.jpg", "MLS_12-1-900x600.jpg", "MLS_13-1-900x600.jpg", "MLS_14-1-900x600.jpg", "MLS_16-1-900x600.jpg", "MLS_17-1-900x600.jpg", "MLS_18-1-900x600.jpg", "MLS_2-2-900x600.jpg", "MLS_20-1-900x600.jpg", "MLS_23-1-900x600.jpg", "MLS_24-1-900x600.jpg", "MLS_25-1-900x600.jpg", "MLS_26-1-900x600.jpg", "MLS_28-1-900x600.jpg", "MLS_29-1-900x600.jpg", "MLS_3-2-900x600.jpg", "MLS_5-1-900x600.jpg", "MLS_7-1-900x600.jpg"],
      },
      {
        id: "172marguerita",
        title: "172 N Marguerita Ave, Alhambra, CA 91801",
        price: "618000",
        sold: true,
        soldDate: "2021-05-05",
        soldPrice: "675000",
        bedroom: "4",
        bathroom: "4",
        livingArea: "1574",
        lotSize: "",
        yearBuild: "1981",
        thumb: true,
        preview: ["MLS_1.jpg", "MLS_11.jpg"],
        pics: ["MLS_1.jpg", "MLS_10.jpg", "MLS_11.jpg", "MLS_12.jpg", "MLS_13.jpg", "MLS_14.jpg", "MLS_15.jpg", "MLS_16.jpg", "MLS_17.jpg", "MLS_18.jpg", "MLS_19.jpg", "MLS_2.jpg", "MLS_20.jpg", "MLS_21.jpg", "MLS_22.jpg", "MLS_23.jpg", "MLS_24.jpg", "MLS_25.jpg", "MLS_26.jpg", "MLS_27.jpg", "MLS_28.jpg", "MLS_29.jpg", "MLS_3.jpg", "MLS_30.jpg", "MLS_31.jpg", "MLS_32.jpg", "MLS_4.jpg", "MLS_5.jpg", "MLS_6.jpg", "MLS_7.jpg", "MLS_8.jpg", "MLS_9.jpg"],
      },
      {
        id: "1351orangeapt210",
        title: "1351 N Orange Dr Apt 210, Los Angeles, CA 90028",
        price: "449000",
        sold: true,
        soldDate: "2021-04-29",
        soldPrice: "439900",
        bedroom: "1",
        bathroom: "1",
        livingArea: "639",
        lotSize: "",
        yearBuild: "1977",
        thumb: true,
        pics: ["MLS_1.jpg", "MLS_10.jpg", "MLS_11.jpg", "MLS_12.jpg", "MLS_13.jpg", "MLS_14.jpg", "MLS_15.jpg", "MLS_16.jpg", "MLS_17.jpg", "MLS_18.jpg", "MLS_19.jpg", "MLS_2.jpg", "MLS_20.jpg", "MLS_21.jpg", "MLS_22.jpg", "MLS_23.jpg", "MLS_24.jpg", "MLS_25.jpg", "MLS_3.jpg", "MLS_4.jpg", "MLS_5.jpg", "MLS_6.jpg", "MLS_7.jpg", "MLS_8.jpg", "MLS_9.jpg"],
      },
      {
        id: "2410NTowneAve",
        title: "2410 N Towne Ave,#41, Pomona CA 91767",
        price: "339000",
        sold: true,
        soldDate: "2021-04-05",
        soldPrice: "355000",
        bedroom: "2",
        bathroom: "2",
        livingArea: "1018",
        lotSize: "",
        yearBuild: "1987",
        thumb: true,
        pics: ["MLS_1.jpg", "MLS_10.jpg", "MLS_11.jpg", "MLS_12.jpg", "MLS_13.jpg", "MLS_14.jpg", "MLS_15.jpg", "MLS_16.jpg", "MLS_17.jpg", "MLS_18.jpg", "MLS_19.jpg", "MLS_2.jpg", "MLS_20.jpg", "MLS_21.jpg", "MLS_22.jpg", "MLS_23.jpg", "MLS_24.jpg", "MLS_3.jpg", "MLS_4.jpg", "MLS_5.jpg", "MLS_6.jpg", "MLS_7.jpg", "MLS_8.jpg", "MLS_9.jpg"],
      },
      {
        id: "858Hillcrest",
        title: "858 Hillcrest St, Walnut, CA 91789",
        price: "1298000",
        sold: true,
        soldDate: "2021-03-19",
        soldPrice: "1288000",
        bedroom: "4",
        bathroom: "3",
        livingArea: "2548",
        lotSize: "",
        lotSizeAcre: "0.44",
        yearBuild: "1988",
        thumb: true,
        pics: ["MLS_1.jpg", "MLS_10.jpg", "MLS_11.jpg", "MLS_12.jpg", "MLS_13.jpg", "MLS_14.jpg", "MLS_15.jpg", "MLS_16.jpg", "MLS_17.jpg", "MLS_18.jpg", "MLS_19.jpg", "MLS_2.jpg", "MLS_20.jpg", "MLS_21.jpg", "MLS_22.jpg", "MLS_23.jpg", "MLS_24.jpg", "MLS_25.jpg", "MLS_26.jpg", "MLS_27.jpg", "MLS_28.jpg", "MLS_29.jpg", "MLS_3.jpg", "MLS_30.jpg", "MLS_31.jpg", "MLS_32.jpg", "MLS_33.jpg", "MLS_34.jpg", "MLS_35.jpg", "MLS_36.jpg", "MLS_37.jpg", "MLS_38.jpg", "MLS_39.jpg", "MLS_4.jpg", "MLS_40.jpg", "MLS_41.jpg", "MLS_42.jpg", "MLS_43.jpg", "MLS_44.jpg", "MLS_45.jpg", "MLS_46.jpg", "MLS_47.jpg", "MLS_48.jpg", "MLS_49.jpg", "MLS_5.jpg", "MLS_50.jpg", "MLS_51.jpg", "MLS_52.jpg", "MLS_53.jpg", "MLS_54.jpg", "MLS_55.jpg", "MLS_6.jpg", "MLS_7.jpg", "MLS_8.jpg", "MLS_9.jpg"],
      },
      {
        id: "111marguerita",
        title: "111 Marguerita Ave #100, Monterey Park, CA 91754",
        price: "268000",
        sold: true,
        soldDate: "2021-03-15",
        soldPrice: "275000",
        bedroom: "1",
        bathroom: "1",
        livingArea: "475",
        lotSize: "",
        yearBuild: "1999",
        thumb: true,
        pics: ["MLS_1.jpg", "MLS_10.jpg", "MLS_11.jpg", "MLS_12.jpg", "MLS_13.jpg", "MLS_14.jpg", "MLS_15.jpg", "MLS_16.jpg", "MLS_17.jpg", "MLS_18.jpg", "MLS_19.jpg", "MLS_2.jpg", "MLS_3.jpg", "MLS_4.jpg", "MLS_5.jpg", "MLS_6.jpg", "MLS_7.jpg", "MLS_8.jpg", "MLS_9.jpg"],
      },
      {
        id: "1385Gabriel",
        title: "1385 S San Gabriel Blvd, San Marino, CA 91108",
        price: "1298000",
        sold: true,
        soldDate: "2021-01-13",
        soldPrice: "1320000",
        bedroom: "3",
        bathroom: "2",
        livingArea: "1816",
        lotSize: "10217",
        yearBuild: "1950",
        thumb: true,
        pics: ["MLS_1.jpg", "MLS_2.jpg", "MLS_3.jpg"],
      },
      {
        id: "5625NWillard",
        title: "5625 N. Willard Ave. San Gabriel, CA 91776",
        price: "838000",
        sold: true,
        soldDate: "2021-01-20",
        soldPrice: "940000",
        bedroom: "3",
        bathroom: "3",
        livingArea: "1625",
        lotSize: "7541",
        yearBuild: "1941",
        thumb: true,
        pics: ["MLS_1.jpg", "MLS_2.jpg", "MLS_3.jpg"],
      },
      {
        id: "626S6",
        title: "626 S 6th St #2, Alhambra, CA 91801",
        price: "518000",
        sold: true,
        soldDate: "2020-12-04",
        soldPrice: "525000",
        bedroom: "3",
        bathroom: "3",
        livingArea: "1185",
        lotSize: "",
        yearBuild: "1983",
        thumb: true,
        pics: ["MLS_1-2-900x600.jpg", "MLS_10-900x600.jpg", "MLS_11-900x600.jpg", "MLS_12-900x600.jpg", "MLS_13-900x600.jpg", "MLS_14-900x600.jpg", "MLS_15-900x600.jpg", "MLS_16-900x600.jpg", "MLS_17-900x600.jpg", "MLS_18-900x600.jpg", "MLS_19-900x600.jpg", "MLS_20-900x600.jpg", "MLS_21-900x600.jpg", "MLS_5-900x600.jpg", "MLS_7-900x600.jpg", "MLS_8-900x600.jpg", "MLS_9-900x600.jpg"],
      },
      {
        id: "626S6_3",
        title: "626 S 6th St #3, Alhambra, CA 91801",
        price: "",
        sold: true,
        soldDate: "2021-01-04",
        soldPrice: "480000",
        bedroom: "3",
        bathroom: "3",
        livingArea: "1185",
        lotSize: "11830",
        yearBuild: "1983",
        thumb: true,
        pics: ["MLS_1-2-900x600.jpg"],
      },
      {
        id: "626S6_4",
        title: "626 S 6th St #4, Alhambra, CA 91801",
        price: "",
        sold: true,
        soldDate: "2020-12-30",
        soldPrice: "508000",
        bedroom: "3",
        bathroom: "3",
        livingArea: "1185",
        lotSize: "11830",
        yearBuild: "1983",
        thumb: true,
        pics: ["MLS_1-2-900x600.jpg"],
      },
      {
        id: "500Norwood",
        title: "500 W Norwood Pl, Alhambra, CA 91803",
        price: "859000",
        sold: true,
        soldDate: "2020-11-12",
        soldPrice: "870000",
        bedroom: "4",
        bathroom: "2",
        livingArea: "900",
        lotSize: "8764",
        yearBuild: "",
        thumb: true,
        pics: ["MLS_1.jpg", "MLS_10.jpg", "MLS_11.jpg", "MLS_12.jpg", "MLS_13.jpg", "MLS_14.jpg", "MLS_15.jpg", "MLS_16.jpg", "MLS_17.jpg", "MLS_18.jpg", "MLS_19.jpg", "MLS_2.jpg", "MLS_20.jpg", "MLS_21.jpg", "MLS_22.jpg", "MLS_23.jpg", "MLS_3.jpg", "MLS_4.jpg", "MLS_5.jpg", "MLS_6.jpg", "MLS_7.jpg", "MLS_8.jpg", "MLS_9.jpg"],
      },
      {
        id: "343New",
        title: "343 S New Ave Unit A, Monterey Park, CA 91755",
        price: "598000",
        sold: true,
        soldDate: "2020-11-18",
        soldPrice: "637000",
        bedroom: "3",
        bathroom: "3",
        livingArea: "1712",
        lotSize: "",
        yearBuild: "1976",
        thumb: true,
        pics: ["MLS_1.jpg", "MLS_10.jpg", "MLS_11.jpg", "MLS_12.jpg", "MLS_13.jpg", "MLS_14.jpg", "MLS_15.jpg", "MLS_16.jpg", "MLS_17.jpg", "MLS_18.jpg", "MLS_19.jpg", "MLS_2.jpg", "MLS_20.jpg", "MLS_21.jpg", "MLS_22.jpg", "MLS_23.jpg", "MLS_24.jpg", "MLS_25.jpg", "MLS_26.jpg", "MLS_27.jpg", "MLS_28.jpg", "MLS_29.jpg", "MLS_3.jpg", "MLS_4.jpg", "MLS_5.jpg", "MLS_6.jpg", "MLS_7.jpg", "MLS_8.jpg", "MLS_9.jpg"],
      },
      {
        id: "326Wistaria",
        title: "326 E Wistaria Ave, Arcadia, CA 91006",
        price: "1198000",
        sold: true,
        soldDate: "",
        soldPrice: "1278000",
        bedroom: "3",
        bathroom: "2",
        livingArea: "2308",
        lotSize: "7928",
        yearBuild: "1950",
        thumb: true,
        pics: ["MLS_1.jpg", "MLS_10.jpg", "MLS_11.jpg", "MLS_12.jpg", "MLS_13.jpg", "MLS_14.jpg", "MLS_15.jpg", "MLS_16.jpg", "MLS_17.jpg", "MLS_18.jpg", "MLS_19.jpg", "MLS_2.jpg", "MLS_20.jpg", "MLS_21.jpg", "MLS_22.jpg", "MLS_23.jpg", "MLS_24.jpg", "MLS_25.jpg", "MLS_26.jpg", "MLS_27.jpg", "MLS_28.jpg", "MLS_29.jpg", "MLS_3.jpg", "MLS_30.jpg", "MLS_31.jpg", "MLS_32.jpg", "MLS_33.jpg", "MLS_34.jpg", "MLS_35.jpg", "MLS_36.jpg", "MLS_37.jpg", "MLS_38.jpg", "MLS_39.jpg", "MLS_4.jpg", "MLS_40.jpg", "MLS_41.jpg", "MLS_42.jpg", "MLS_43.jpg", "MLS_44.jpg", "MLS_45.jpg", "MLS_46.jpg", "MLS_47.jpg", "MLS_48.jpg", "MLS_49.jpg", "MLS_5.jpg", "MLS_6.jpg", "MLS_7.jpg", "MLS_8.jpg", "MLS_9.jpg"],
      },
      {
        id: "274Dominguez",
        title: "274 N Dominguez Pl, Azusa, CA 91702",
        price: "580000",
        sold: true,
        soldDate: "",
        soldPrice: "5750000",
        bedroom: "3",
        bathroom: "1.5",
        livingArea: "2084",
        lotSize: "6097",
        yearBuild: "1964",
        thumb: true,
        pics: ["MLS_1-900x600.jpg", "MLS_10-900x600.jpg", "MLS_11-900x600.jpg", "MLS_12-900x600.jpg", "MLS_13-900x600.jpg", "MLS_14-900x600.jpg", "MLS_15-900x600.jpg", "MLS_16-900x600.jpg", "MLS_17-900x600.jpg", "MLS_18-900x600.jpg", "MLS_19-900x600.jpg", "MLS_20-900x600.jpg", "MLS_21-900x600.jpg", "MLS_22-900x600.jpg", "MLS_23-900x600.jpg", "MLS_24-800x600.jpg", "MLS_25-900x600.jpg", "MLS_26-900x600.jpg", "MLS_27-900x600.jpg", "MLS_30-900x600.jpg", "MLS_31-900x600.jpg", "MLS_32-900x600.jpg", "MLS_33-900x600.jpg", "MLS_4-900x600.jpg", "MLS_5-900x600.jpg", "MLS_6-900x600.jpg", "MLS_7-900x600.jpg", "MLS_8-900x600.jpg", "MLS_9-900x600.jpg"],
      },
      {
        id: "520Coyle",
        title: "520 Coyle Ave, Arcadia",
        price: "2180000",
        sold: true,
        soldDate: "2020-09-18",
        soldPrice: "2000000",
        bedroom: "4",
        bathroom: "4.5",
        livingArea: "3879",
        lotSize: "8561",
        yearBuild: "2018",
        thumb: true,
        pics: [
          "MLS_1.jpg",
          "MLS_10.jpg",
          "MLS_11.jpg",
          "MLS_12.jpg",
          "MLS_13.jpg",
          "MLS_14.jpg",
          "MLS_15.jpg",
          "MLS_16.jpg",
          "MLS_17.jpg",
          "MLS_18.jpg",
          "MLS_19.jpg",
          "MLS_2.jpg",
          "MLS_20.jpg",
          "MLS_21.jpg",
          "MLS_22.jpg",
          "MLS_23.jpg",
          "MLS_24.jpg",
          "MLS_25.jpg",
          "MLS_26.jpg",
          "MLS_27.jpg",
          "MLS_28.jpg",
          "MLS_29.jpg",
          "MLS_3.jpg",
          "MLS_30.jpg",
          "MLS_31.jpg",
          "MLS_32.jpg",
          "MLS_33.jpg",
          "MLS_34.jpg",
          "MLS_35.jpg",
          "MLS_36.jpg",
          "MLS_37.jpg",
          "MLS_38.jpg",
          "MLS_39.jpg",
          "MLS_4.jpg",
          "MLS_40.jpg",
          "MLS_41.jpg",
          "MLS_42.jpg",
          "MLS_43.jpg",
          "MLS_44.jpg",
          "MLS_45.jpg",
          "MLS_46.jpg",
          "MLS_47.jpg",
          "MLS_48.jpg",
          "MLS_49.jpg",
          "MLS_5.jpg",
          "MLS_50.jpg",
          "MLS_51.jpg",
          "MLS_52.jpg",
          "MLS_53.jpg",
          "MLS_54.jpg",
          "MLS_55.jpg",
          "MLS_56.jpg",
          "MLS_57.jpg",
          "MLS_58.jpg",
          "MLS_59.jpg",
          "MLS_6.jpg",
          "MLS_60.jpg",
          "MLS_61.jpg",
          "MLS_62.jpg",
          "MLS_7.jpg",
          "MLS_8.jpg",
          "MLS_9.jpg",
        ],
      },
      {
        id: "221Violet",
        title: "221 Violet Ave #A, Monrovia, CA 91016",
        price: "548000",
        sold: true,
        soldDate: "2020-09-16",
        soldPrice: "565000",
        bedroom: "2",
        bathroom: "2",
        livingArea: "1490",
        lotSize: "",
        yearBuild: "1994",
        thumb: true,
        pics: ["MLS_1-900x600.jpg", "MLS_10-1-900x600.jpg", "MLS_12-1-900x600.jpg", "MLS_13-1-900x600.jpg", "MLS_14-1-900x600.jpg", "MLS_15-1-900x600.jpg", "MLS_16-1-900x600.jpg", "MLS_17-1-900x600.jpg", "MLS_18-1-900x600.jpg", "MLS_19-1-900x600.jpg", "MLS_20-1-900x600.jpg", "MLS_5-1-900x600.jpg", "MLS_6-1-900x600.jpg", "MLS_7-1-900x600.jpg", "MLS_8-1-900x600.jpg", "MLS_9-1-900x600.jpg"],
      },
      {
        id: "2033S3",
        title: "2033 S 3rd St, Alhambra, CA 91803",
        price: "868000",
        sold: true,
        soldDate: "2020-09-09",
        soldPrice: "878000",
        bedroom: "4",
        bathroom: "2",
        livingArea: "1724",
        lotSize: "7553",
        yearBuild: "1920",
        thumb: true,
        pics: ["MLS_1-900x600.jpg", "MLS_10-900x600.jpg", "MLS_11-900x600.jpg", "MLS_13-900x600.jpg", "MLS_14-900x600.jpg", "MLS_15-900x600.jpg", "MLS_16-900x600.jpg", "MLS_17-900x600.jpg", "MLS_18-900x600.jpg", "MLS_21-900x600.jpg", "MLS_25-900x600.jpg", "MLS_27-900x600.jpg", "MLS_5-900x600.jpg", "MLS_7-900x600.jpg", "MLS_8-900x600.jpg", "MLS_9-900x600.jpg"],
      },
      {
        id: "1024S1st",
        title: "1024 S 1st St, Alhambra",
        price: "848000",
        sold: true,
        soldDate: "2020-09-09",
        soldPrice: "830000",
        bedroom: "3",
        bathroom: "2",
        livingArea: "1572",
        lotSize: "6327",
        yearBuild: "1931",
        thumb: true,
        pics: ["MLS_1.jpg", "MLS_10.jpg", "MLS_11.jpg", "MLS_12.jpg", "MLS_13.jpg", "MLS_14.jpg", "MLS_15.jpg", "MLS_16.jpg", "MLS_17.jpg", "MLS_18.jpg", "MLS_19.jpg", "MLS_2.jpg", "MLS_20.jpg", "MLS_21.jpg", "MLS_22.jpg", "MLS_23.jpg", "MLS_24.jpg", "MLS_25.jpg", "MLS_26.jpg", "MLS_27.jpg", "MLS_28.jpg", "MLS_29.jpg", "MLS_3.jpg", "MLS_30.jpg", "MLS_31.jpg", "MLS_32.jpg", "MLS_33.jpg", "MLS_34.jpg", "MLS_35.jpg", "MLS_36.jpg", "MLS_37.jpg", "MLS_38.jpg", "MLS_39.jpg", "MLS_4.jpg", "MLS_40.jpg", "MLS_41.jpg", "MLS_42.jpg", "MLS_43.jpg", "MLS_44.jpg", "MLS_5.jpg", "MLS_6.jpg", "MLS_7.jpg", "MLS_8.jpg", "MLS_9.jpg"],
      },
      {
        id: "3829Gilman",
        title: "3829 Gilman Rd, El Monte, CA 91732",
        price: "508000",
        sold: true,
        soldDate: "2020-08-26",
        soldPrice: "538000",
        bedroom: "3",
        bathroom: "3",
        livingArea: "1510",
        lotSize: "",
        yearBuild: "1989",
        thumb: true,
        pics: ["MLS_1.jpg", "MLS_10.jpg", "MLS_11.jpg", "MLS_12.jpg", "MLS_13.jpg", "MLS_14.jpg", "MLS_15.jpg", "MLS_16.jpg", "MLS_17.jpg", "MLS_18    .jpg", "MLS_19.jpg", "MLS_2.jpg", "MLS_20.jpg", "MLS_21.jpg", "MLS_22.jpg", "MLS_23.jpg", "MLS_24.jpg", "MLS_25.jpg", "MLS_26.jpg", "MLS_27.jpg", "MLS_3.jpg", "MLS_4.jpg", "MLS_5.jpg", "MLS_6.jpg", "MLS_7.jpg", "MLS_8.jpg", "MLS_9.jpg"],
      },
      {
        id: "412S5thStAlhambra",
        title: "412 & 414 S 5th St, Alhambra, CA 91801",
        price: "998000",
        sold: true,
        soldDate: "2020-08-16",
        soldPrice: "993000",
        bedroom: "4",
        bathroom: "4",
        livingArea: "2328",
        lotSize: "7501",
        yearBuild: "",
        thumb: true,
        pics: ["MLS_1.jpg", "MLS_10.jpg", "MLS_11.jpg", "MLS_12.jpg", "MLS_13.jpg", "MLS_14.jpg", "MLS_15.jpg", "MLS_16.jpg", "MLS_17.jpg", "MLS_18.jpg", "MLS_19.jpg", "MLS_2.jpg", "MLS_20.jpg", "MLS_21.jpg", "MLS_22.jpg", "MLS_23.jpg", "MLS_24.jpg", "MLS_25.jpg", "MLS_3.jpg", "MLS_4.jpg", "MLS_5.jpg", "MLS_6.jpg", "MLS_7.jpg", "MLS_8.jpg", "MLS_9.jpg"],
      },
      {
        id: "116sChapel",
        title: "116 S Chapel Ave, Alhambra",
        price: "518000",
        sold: true,
        soldDate: "2020-06-16",
        soldPrice: "519500",
        bedroom: "2",
        bathroom: "3",
        livingArea: "1249",
        lotSize: "",
        yearBuild: "1980",
        thumb: true,
        pics: ["MLS_1.jpg", "MLS_10.jpg", "MLS_11.jpg", "MLS_12.jpg", "MLS_13.jpg", "MLS_14.jpg", "MLS_15.jpg", "MLS_16.jpg", "MLS_17.jpg", "MLS_18.jpg", "MLS_19.jpg", "MLS_2.jpg", "MLS_20.jpg", "MLS_21.jpg", "MLS_22.jpg", "MLS_23.jpg", "MLS_24.jpg", "MLS_25.jpg", "MLS_26.jpg", "MLS_27.jpg", "MLS_28.jpg", "MLS_29.jpg", "MLS_3.jpg", "MLS_30.jpg", "MLS_4.jpg", "MLS_5.jpg", "MLS_6.jpg", "MLS_7.jpg", "MLS_8.jpg", "MLS_9.jpg"],
      },
      {
        id: "1944Charnwood",
        title: "1944 Charnwood Ave, Alhambra",
        price: "548000",
        sold: true,
        soldDate: "2020-05-23",
        soldPrice: "610000",
        bedroom: "2",
        bathroom: "1",
        livingArea: "735",
        lotSize: "5000",
        yearBuild: "1925",
        thumb: true,
        pics: ["MLS_1.jpg", "MLS_10.jpg", "MLS_11.jpg", "MLS_12.jpg", "MLS_13.jpg", "MLS_14.jpg", "MLS_15.jpg", "MLS_16.jpg", "MLS_17.jpg", "MLS_18.jpg", "MLS_19.jpg", "MLS_2.jpg", "MLS_20.jpg", "MLS_21.jpg", "MLS_22.jpg", "MLS_23.jpg", "MLS_24.jpg", "MLS_25.jpg", "MLS_26.jpg", "MLS_3.jpg", "MLS_4.jpg", "MLS_5.jpg", "MLS_6.jpg", "MLS_7.jpg", "MLS_8.jpg", "MLS_9.jpg"],
      },
      {
        id: "3235Nevada",
        title: "3235 Nevada Ave, El Monte, CA 91731",
        price: "568000",
        sold: true,
        soldDate: "2020-04-29",
        soldPrice: "590000",
        bedroom: "3",
        bathroom: "2",
        livingArea: "1554",
        lotSize: "7134",
        yearBuild: "",
        thumb: true,
        pics: ["MLS_1.jpg", "MLS_10.jpg", "MLS_11.jpg", "MLS_12.jpg", "MLS_13.jpg", "MLS_14.jpg", "MLS_15.jpg", "MLS_16.jpg", "MLS_17.jpg", "MLS_18.jpg", "MLS_19.jpg", "MLS_2.jpg", "MLS_20.jpg", "MLS_21.jpg", "MLS_22.jpg", "MLS_23.jpg", "MLS_24.jpg", "MLS_25.jpg", "MLS_26.jpg", "MLS_27.jpg", "MLS_28.jpg", "MLS_3.jpg", "MLS_4.jpg", "MLS_5.jpg", "MLS_6.jpg", "MLS_7.jpg", "MLS_8.jpg", "MLS_9.jpg"],
      },
      // {
      //   id: '1445Oak',
      //   title: '1445 Oak Grove Ave., San Marino, CA 91108',
      //   price: '3980000',
      //   leased: true,
      //   soldDate: '',
      //   soldPrice: '',
      //   bedroom: '4',
      //   bathroom: '4.5',
      //   livingArea: '4978',
      //   lotSize: '',
      //   yearBuild: '1952',
      //   thumb: true,
      //   pics: ['00_House_Front.jpg', '01_Entry.jpg', '01_Living_room_1.jpg', '02_Dining_room.jpg', '03_Kitchen_1.jpg', '04_Downstairs_master_bedroom.jpg', '04a_Donwstairs_master_bathroom.jpg', '06_Master_suite.jpg', '06a_Maste_bathroom_1.jpg', '08_Family_room_1.jpg', '11_Covered_deck_and_backyard.jpg', '12_Pool_and_house_back_1.jpg', '13_Driveway.jpg']
      // },
      {
        id: "9070Huntington10",
        title: "9070 Huntington Blvd, #10, San Gabriel, CA 91775",
        price: "458000",
        sold: true,
        soldDate: "2020-04-07",
        soldPrice: "468000",
        bedroom: "2",
        bathroom: "2",
        livingArea: "1031",
        lotSize: "",
        yearBuild: "1963",
        thumb: true,
        pics: ["MLS_1.jpg", "MLS_10.jpg", "MLS_11.jpg", "MLS_12.jpg", "MLS_13.jpg", "MLS_14.jpg", "MLS_15.jpg", "MLS_16.jpg", "MLS_17.jpg", "MLS_18.jpg", "MLS_19.jpg", "MLS_2.jpg", "MLS_20.jpg", "MLS_3.jpg", "MLS_4.jpg", "MLS_5.jpg", "MLS_6.jpg", "MLS_7.jpg", "MLS_8.jpg", "MLS_9.jpg"],
      },
      {
        id: "1522sunbluff",
        title: "1522 Sunbluff Dr, Diamond Bar, CA 91765",
        price: "928000",
        sold: true,
        soldDate: "2020-03-27",
        soldPrice: "910000",
        bedroom: "4",
        bathroom: "2.5",
        livingArea: "2577",
        lotSize: "9139",
        yearBuild: "1981",
        thumb: true,
        pics: ["MLS_1.jpg", "MLS_2.jpg", "MLS_3.jpg", "MLS_4.jpg", "MLS_5.jpg", "MLS_6.jpg", "MLS_7.jpg", "MLS_8.jpg", "MLS_9.jpg", "MLS_10.jpg", "MLS_11.jpg", "MLS_12.jpg", "MLS_13.jpg", "MLS_14.jpg", "MLS_15.jpg", "MLS_16.jpg", "MLS_17.jpg", "MLS_18.jpg", "MLS_19.jpg", "MLS_20.jpg", "MLS_21.jpg", "MLS_22.jpg", "MLS_23.jpg", "MLS_24.jpg", "MLS_25.jpg", "MLS_26.jpg", "MLS_27.jpg", "MLS_28.jpg", "MLS_29.jpg", "MLS_30.jpg", "MLS_31.jpg", "MLS_32.jpg", "MLS_33.jpg", "MLS_34.jpg", "MLS_35.jpg", "MLS_36.jpg", "MLS_37.jpg", "MLS_38.jpg"],
      },
      {
        id: "14343Redwood",
        title: "14343 Redwood Valley Road Eastvale, CA 92880",
        price: "575000",
        sold: true,
        soldDate: "2020-02-27",
        soldPrice: "540000",
        bedroom: "3",
        bathroom: "2.5",
        livingArea: "2376",
        lotSize: "7841",
        yearBuild: "2008",
        thumb: true,
        pics: ["MLS_1.jpg", "MLS_10.jpg", "MLS_11.jpg", "MLS_12.jpg", "MLS_13.jpg", "MLS_14.jpg", "MLS_15.jpg", "MLS_16.jpg", "MLS_17.jpg", "MLS_18.jpg", "MLS_19.jpg", "MLS_2.jpg", "MLS_20.jpg", "MLS_21.jpg", "MLS_22.jpg", "MLS_23.jpg", "MLS_24.jpg", "MLS_25.jpg", "MLS_26.jpg", "MLS_27.jpg", "MLS_28.jpg", "MLS_29.jpg", "MLS_3.jpg", "MLS_30.jpg", "MLS_31.jpg", "MLS_32.jpg", "MLS_33.jpg", "MLS_34.jpg", "MLS_35.jpg", "MLS_4.jpg", "MLS_5.jpg", "MLS_6.jpg", "MLS_7.jpg", "MLS_8.jpg", "MLS_9.jpg"],
      },
      {
        id: "336N4thSt",
        title: "336 N 4th Street Unit#D, Alhambra, CA 91801",
        price: "498000",
        sold: true,
        soldDate: "2020-02-20",
        soldPrice: "515000",
        bedroom: "3",
        bathroom: "2.5",
        livingArea: "1191",
        lotSize: "",
        yearBuild: "1984",
        thumb: true,
        pics: ["MLS_1.jpg", "MLS_10.jpg", "MLS_11.jpg", "MLS_12.jpg", "MLS_13.jpg", "MLS_14.jpg", "MLS_15.jpg", "MLS_16.jpg", "MLS_17.jpg", "MLS_18.jpg", "MLS_19.jpg", "MLS_2.jpg", "MLS_20.jpg", "MLS_21.jpg", "MLS_22.jpg", "MLS_23.jpg", "MLS_24.jpg", "MLS_25.jpg", "MLS_26.jpg", "MLS_3.jpg", "MLS_4.jpg", "MLS_5.jpg", "MLS_6.jpg", "MLS_7.jpg", "MLS_8.jpg", "MLS_9.jpg"],
      },
      {
        id: "68S5",
        title: "68 S. 5th St, #G, Alhambra, CA 91801",
        price: "788000",
        sold: true,
        soldDate: "2020-02-07",
        soldPrice: "785000",
        bedroom: "4",
        bathroom: "3.5",
        livingArea: "1760",
        lotSize: "",
        yearBuild: "2011",
        thumb: true,
        pics: ["MLS_1.jpg", "MLS_10.jpg", "MLS_11.jpg", "MLS_12.jpg", "MLS_13.jpg", "MLS_14.jpg", "MLS_15.jpg", "MLS_16.jpg", "MLS_17.jpg", "MLS_18.jpg", "MLS_19.jpg", "MLS_2.jpg", "MLS_20.jpg", "MLS_21.jpg", "MLS_22.jpg", "MLS_23.jpg", "MLS_24.jpg", "MLS_25.jpg", "MLS_26.jpg", "MLS_27.jpg", "MLS_28.jpg", "MLS_29.jpg", "MLS_3.jpg", "MLS_30.jpg", "MLS_31.jpg", "MLS_32.jpg", "MLS_33.jpg", "MLS_34.jpg", "MLS_35.jpg", "MLS_36.jpg", "MLS_37.jpg", "MLS_38.jpg", "MLS_39.jpg", "MLS_4.jpg", "MLS_40.jpg", "MLS_41.jpg", "MLS_42.jpg", "MLS_43.jpg", "MLS_44.jpg", "MLS_45.jpg", "MLS_46.jpg", "MLS_47.jpg", "MLS_48.jpg", "MLS_49.jpg", "MLS_5.jpg", "MLS_50.jpg", "MLS_51.jpg", "MLS_6.jpg", "MLS_7.jpg", "MLS_8.jpg", "MLS_9.jpg"],
      },
      {
        id: "1020SElMolino",
        title: "1020 S. El Molino St, Alhambra, CA 91801",
        price: "718000",
        sold: true,
        soldDate: "2019-12-28",
        soldPrice: "748000",
        bedroom: "2",
        bathroom: "2",
        livingArea: "1177",
        lotSize: "5772",
        yearBuild: "",
        thumb: true,
        pics: ["MLS_1.jpg", "MLS_10.jpg", "MLS_11.jpg", "MLS_12.jpg", "MLS_13.jpg", "MLS_14.jpg", "MLS_15.jpg", "MLS_16.jpg", "MLS_17.jpg", "MLS_18.jpg", "MLS_19.jpg", "MLS_2.jpg", "MLS_20.jpg", "MLS_21.jpg", "MLS_22.jpg", "MLS_23.jpg", "MLS_24.jpg", "MLS_25.jpg", "MLS_26.jpg", "MLS_27.jpg", "MLS_28.jpg", "MLS_29.jpg", "MLS_3.jpg", "MLS_30.jpg", "MLS_31.jpg", "MLS_32.jpg", "MLS_33.jpg", "MLS_34.jpg", "MLS_35.jpg", "MLS_4.jpg", "MLS_5.jpg", "MLS_6.jpg", "MLS_7.jpg", "MLS_8.jpg", "MLS_9.jpg"],
      },
      {
        id: "1140SVega",
        title: "1140 S. Vega St, Alhambra, CA 91801",
        price: "698000",
        sold: true,
        soldDate: "2019-11-26",
        soldPrice: "775000",
        bedroom: "3",
        bathroom: "1",
        livingArea: "1212",
        lotSize: "5869",
        yearBuild: "",
        thumb: true,
        pics: ["MLS_1.jpg", "MLS_10.jpg", "MLS_11.jpg", "MLS_12.jpg", "MLS_13.jpg", "MLS_14.jpg", "MLS_15.jpg", "MLS_16.jpg", "MLS_17.jpg", "MLS_18.jpg", "MLS_19.jpg", "MLS_2.jpg", "MLS_20.jpg", "MLS_21.jpg", "MLS_22.jpg", "MLS_23.jpg", "MLS_24.jpg", "MLS_25.jpg", "MLS_26.jpg", "MLS_3.jpg", "MLS_4.jpg", "MLS_5.jpg", "MLS_6.jpg", "MLS_7.jpg", "MLS_8.jpg", "MLS_9.jpg"],
      },
      {
        id: "819WDuarte",
        title: "819 W Duarte Rd, Arcadia, CA 91007",
        price: "828000",
        sold: true,
        soldDate: "2019-09-06",
        soldPrice: "810800",
        bedroom: "4",
        bathroom: "3",
        livingArea: "2070",
        lotSize: "",
        yearBuild: "1986",
        thumb: true,
        pics: ["MLS_01.jpg", "MLS_02.jpg", "MLS_03.jpg", "MLS_04.jpg", "MLS_05.jpg", "MLS_06.jpg", "MLS_07.jpg", "MLS_08.jpg", "MLS_09.jpg", "MLS_10.jpg", "MLS_11.jpg", "MLS_12.jpg", "MLS_13.jpg", "MLS_14.jpg", "MLS_15.jpg", "MLS_16.jpg", "MLS_17.jpg", "MLS_18.jpg", "MLS_19.jpg", "MLS_20.jpg", "MLS_21.jpg", "MLS_22.jpg", "MLS_23.jpg", "MLS_24.jpg", "MLS_25.jpg", "MLS_26.jpg", "MLS_27.jpg", "MLS_28.jpg", "MLS_29.jpg", "MLS_30.jpg", "MLS_31.jpg", "MLS_32.jpg", "MLS_33.jpg", "MLS_34.jpg", "MLS_35.jpg", "MLS_36.jpg", "MLS_37.jpg", "MLS_38.jpg", "MLS_39.jpg"],
      },
      {
        id: "5301VIllageCircle",
        title: "5301 Village Circle Dr, Temple City, CA 91780",
        price: "628000",
        sold: true,
        soldDate: "2019-08-16",
        soldPrice: "590000",
        bedroom: "3",
        bathroom: "3",
        livingArea: "1458",
        lotSize: "",
        yearBuild: "1975",
        thumb: true,
        picsWithTitle: [
          { pic: "00_House_Front.jpg", title: "House Front" },
          { pic: "01_Entry.jpg", title: "Entry" },
          { pic: "01_Living_room_.jpg", title: "Living room" },
          { pic: "03_Kitchen.jpg", title: "Kitchen" },
          { pic: "05a_Master_bath.jpg", title: "Master bathroom" },
          { pic: "05a_Master_bathr.jpg", title: "Master bathroom" },
          { pic: "05b_Balcony_off.jpg", title: "Balcony off Master bedroom" },
          { pic: "07_Enclosed_pat.jpg", title: "Enclosed patio" },
          {
            pic: "08_Community_Po.jpg",
            title: "Community Pool",
          },
          {
            pic: "08_Community_Poo.jpg",
            title: "Community Pool",
          },
        ],
      },
      {
        id: "2100Cedar",
        title: "2100 Cedar St, #A, Alhambra, CA 91801",
        price: "",
        sold: true,
        soldDate: "2019-08-29",
        soldPrice: "595000",
        bedroom: "3",
        bathroom: "2.5",
        livingArea: "1397",
        lotSize: "",
        yearBuild: "1982",
        thumb: true,
        pics: ["MLS_1.jpg", "MLS_10.jpg", "MLS_11.jpg", "MLS_12.jpg", "MLS_13.jpg", "MLS_14.jpg", "MLS_15.jpg", "MLS_16.jpg", "MLS_17.jpg", "MLS_18.jpg", "MLS_19.jpg", "MLS_2.jpg", "MLS_20.jpg", "MLS_21.jpg", "MLS_22.jpg", "MLS_23.jpg", "MLS_24.jpg", "MLS_25.jpg", "MLS_26.jpg", "MLS_27.jpg", "MLS_28.jpg", "MLS_29.jpg", "MLS_3.jpg", "MLS_30.jpg", "MLS_31.jpg", "MLS_32.jpg", "MLS_4.jpg", "MLS_5.jpg", "MLS_6.jpg", "MLS_7.jpg", "MLS_8.jpg", "MLS_9.jpg"],
      },
      {
        id: "228NMargerutia",
        title: "228 N Margerutia Ave., #E, Alhambra, CA 91801",
        price: "648000",
        sold: true,
        soldDate: "2019-05-24",
        soldPrice: "648000",
        bedroom: "3",
        bathroom: "3",
        livingArea: "1424",
        lotSize: "",
        yearBuild: "1992",
        thumb: true,
        picsWithTitle: [
          { pic: "00_House_front.jpg", title: "House front" },
          { pic: "01_Living_room.jpg", title: "Living room" },
          { pic: "02_Dining_room.jpg", title: "Dining room" },
          { pic: "03_Kitchen.jpg", title: "Kitchen" },
          { pic: "05_Master_bedroom.jpg", title: "Master bedroom" },
          { pic: "05a_Master_bathroom.jpg", title: "Master bathroom" },
          { pic: "07_Back_Yard.jpg", title: "Back Yard" },
          { pic: "08_Common_Area.jpg", title: "Common Area" },
        ],
      },
      {
        id: "430WCaminoReal",
        title: "430 W Camino Real Ave., Arcadia, CA 91007",
        price: "2580000",
        sold: true,
        soldDate: "2019-04-19",
        soldPrice: "2385000",
        bedroom: "5",
        bathroom: "6",
        livingArea: "4425",
        lotSize: "9781",
        yearBuild: "2017",
        thumb: true,
        pics: ["MLS_1.jpg", "MLS_3.jpg", "01_Entry_with_high_ceiling.jpg", "02_Living_room_1.jpg", "02a_Dining_room.jpg", "03_Family_room_1.jpg", "04_Kitchen_Family_room.jpg", "04b_Wok_room.jpg", "05_Downstairs_bedroom.jpg", "05a_Downstairs_bathroom.jpg", "05b_Office.jpg", "07_Master_bedroom_Retreat_area.jpg", "07_Master_bedroom.jpg", "07a_Master_bathroom_1.jpg", "08_Bedroom_1.jpg", "MLS_5.jpg", "MLS_6.jpg", "MLS_8.jpg"],
      },
      {
        id: "128Park",
        title: "128 Park St, Alhambra CA 91801",
        price: "498000",
        sold: true,
        soldDate: "2019-04-22",
        soldPrice: "532000",
        bedroom: "2",
        bathroom: "3",
        livingArea: "1092",
        lotSize: "",
        yearBuild: "1998",
        thumb: true,
        picsWithTitle: [
          { pic: "00_House_Front.jpg", title: "House Front" },
          { pic: "01_Living_room.jpg", title: "Living room" },
          { pic: "03_Kitchen.jpg", title: "Kitchen" },
          { pic: "05_Family_room.jpg", title: "Family room has two sliding doors to exterior" },
          { pic: "07_Master_bedroom.jpg", title: "Master bedroom with bay window" },
          { pic: "07a_Mater_bathroom.jpg", title: "Master bathroom" },
          { pic: "09_House_back.jpg", title: "House back side" },
        ],
      },
      {
        id: "529Farivew",
        title: "529 Farivew Ave., Arcadia, CA 91107",
        price: "778000",
        sold: true,
        soldDate: "2019-09-04",
        soldPrice: "750000",
        bedroom: "3",
        bathroom: "3",
        livingArea: "1842",
        lotSize: "",
        yearBuild: "1964",
        thumb: true,
        picsWithTitle: [
          { pic: "00_Community_Front.jpg", title: "Community Front" },
          { pic: "00_Community_Water_Falls.jpg", title: "Community Water Falls" },
          { pic: "01_High_ceiling_living_room.jpg", title: "High ceiling living room with fireplace" },
          { pic: "01_Living_room.jpg", title: "Living room has sliding doors to front patio" },
          { pic: "02_dining_room.jpg", title: "Stepped up formal dining room" },
          { pic: "03_kitchen.jpg", title: "Upgraded kitchen" },
          { pic: "04_Bathroom_downstairs.jpg", title: "Bathroom downstairs" },
          { pic: "04_Bedroom_Downstairs.jpg", title: "Bedroom Downstairs" },
          { pic: "05_Master_bedroom_1.jpg", title: "Master bedroom with private bath" },
          { pic: "05_Master_bedroom_2.jpg", title: "Master bedroom with wall to wall custom builtin closets" },
          { pic: "05a_Master_bathroom.jpg", title: "Remolded Master bathroom" },
          { pic: "06_2nd_Master_bathroom.jpg", title: "2nd Master bathroom" },
          { pic: "07_Huge_deck.jpg", title: "Huge deck" },
          { pic: "08_Cozy_front_patio.jpg", title: "Cozy front patio" },
        ],
      },
      {
        id: "527SantaMaria",
        title: "527 Santa Maria Rd., Arcadia,  CA 91007",
        price: "2380000",
        sold: true,
        soldDate: "2019-03-21",
        soldPrice: "2210000",
        bedroom: "4",
        bathroom: "4.5",
        livingArea: "4121",
        lotSize: "",
        yearBuild: "2019",
        thumb: true,
        pics: ["00_House_Front.jpg", "00b_Front_door.jpg", "01_Court_yard.jpg", "02a_Foyer.jpg", "03a_Livingroom.jpg", "05_Kitchen_with_waterfall_island.jpg", "08a_Master_bedroom_1.jpg", "08b_Master_bathroom_1.jpg", "09d_House_back.jpg"],
      },
      {
        id: "212NMarguerita",
        title: "212 N Marguerita Ave., #E, Alhambra, CA 91801",
        price: "588000",
        sold: true,
        soldDate: "2019-02-26",
        soldPrice: "565000",
        bedroom: "3",
        bathroom: "3",
        livingArea: "1454",
        lotSize: "",
        yearBuild: "1979",
        thumb: true,
        pics: ["01_Front.jpg", "01_Living_room.jpg", "03_Family_Kitchen.jpg", "04_Kitchen_1.jpg", "05_Master_bedroom_1.jpg", "05a_Master_bathroom.jpg"],
      },
      {
        id: "818S2ndAveArcadia",
        sold: true,
        title: "818 S. 2nd Ave., #B, Arcadia, CA 91006",
        price: "898000",
        soldDate: "2018-06-12",
        soldPrice: "917000",
        bedroom: "3",
        bathroom: "3",
        livingArea: "2064",
        lotSize: "",
        yearBuild: "2002",
        thumb: true,
        pics: ["00_Front.jpg", "01_Living_room_4.jpg", "01_Living_room_Dining_room_1.jpg", "03_Den_Downstatis.jpg", "04_Kitchen_1.jpg", "06_Upstairs_loft.jpg", "07_Master_bedroom.jpg", "07_Master_bedroom_Walk-in_closet.jpg", "07a_Master_bathroom_1.jpg", "08_Hallway_Bathroom.jpg"],
      },
      {
        id: "1117Fairview",
        sold: true,
        title: "1117 Fairview Av, Arcadia 91007",
        price: "848000",
        soldDate: "2018-06-04",
        soldPrice: "850000",
        bedroom: "3",
        bathroom: "3",
        livingArea: "2041",
        lotSize: "",
        yearBuild: "2002",
        thumb: true,
        pics: ["MLS_03.jpg", "MLS_07.jpg", "MLS_12.jpg", "MLS_17.jpg", "MLS_19.jpg", "MLS_24.jpg", "MLS_28.jpg", "MLS_29.jpg"],
      },
      {
        id: "2406S4th",
        sold: true,
        title: "2406 S 4th, Arcadia, CA 91007",
        price: "",
        soldDate: "",
        soldPrice: "1180000",
        bedroom: "3",
        bathroom: "3",
        livingArea: "1995",
        lotSize: "15597",
        yearBuild: "1951",
        thumb: true,
        pics: ["01_House_front.jpg", "01_Living_room.jpg", "02_Dining_area_1.jpg", "03_Kitchen_1.jpg", "04_Family_room.jpg", "05_Master_bedroom_1.jpg", "05a_Master_bathroom.jpg", "07_Drive_way.jpg"],
      },
      {
        id: "513WCommonwealth",
        sold: true,
        title: "513 W Commonwealth Ave, Alhambra, CA 91801",
        price: "",
        soldDate: "2018-05-10",
        soldPrice: "550000",
        bedroom: "2",
        bathroom: "1",
        livingArea: "878",
        lotSize: "2446",
        yearBuild: "1954",
        thumb: true,
        pics: ["00_Front.jpg", "00a_FrontYard.jpg", "01_Livingroom_1.jpg", "02_Diningarea.jpg", "03_Kitchen.jpg", "03_Kitchen_1.jpg", "04_Bedroom_2.jpg", "05_Bedroom_1.jpg", "06_Bathroom.jpg", "07_Laundryroom.jpg", "08_Side_yard.jpg"],
      },
      {
        id: "1001Loma",
        sold: true,
        title: "1001 Loma Verde St, Monterey Park CA 91754",
        price: "",
        soldDate: "2018-02-28",
        soldPrice: "700000",
        bedroom: "3",
        bathroom: "2",
        livingArea: "1231",
        lotSize: "",
        yearBuild: "1948",
        thumb: true,
        pics: ["00_House_Front.jpg", "01_Living_room.jpg", "02_Dining_oom.jpg", "04_Master_bedroom_1.jpg", "06_Bathroom.jpg", "09_Drive_way.jpg", "09a_Backyard_2.jpg"],
      },
      {
        id: "2616Grand",
        sold: true,
        title: "2616 W Grand Ave., #A, Alhambra, CA 91801",
        price: "",
        soldDate: "2018-03-02",
        soldPrice: "565000",
        bedroom: "3",
        bathroom: "2.5",
        livingArea: "1374",
        lotSize: "",
        yearBuild: "1983",
        thumb: true,
        pics: ["00_Front_1.jpg", "00a_Front_door.jpg", "01_Entry_1.jpg", "01_Living_room.jpg", "02_Dining_room_1.jpg", "03_Kitchen_1.jpg", "05_Master_bedroom.jpg", "05a_Master_batrhoom.jpg"],
      },
      {
        id: "8375Village",
        sold: true,
        title: "8375 Village Ln, Rosemead, CA 91770",
        price: "",
        soldDate: "2018-02-15",
        soldPrice: "539988",
        bedroom: "3",
        bathroom: "3",
        livingArea: "1829",
        lotSize: "",
        yearBuild: "1979",
        thumb: true,
        pics: ["00_Front_1.jpg", "01_Living_room.jpg", "02_Dining_room.jpg", "03_Kitchen_1.jpg", "05_Master_bedroom_1.jpg", "05a_Master_bathroom.jpg", "06_2nd_bedroom_with_view.jpg", "06_View_from_bedroom.jpg", "07_Enclosed_front_patio.jpg", "07_Tennis_court.jpg", "07a_Community_Pool.jpg"],
      },
      {
        id: "201laFrance",
        sold: true,
        title: "201 La France Ave., #A, CA 91801",
        price: "605000",
        soldDate: "2018-04-13",
        soldPrice: "980000",
        bedroom: "3",
        bathroom: "3",
        livingArea: "1445",
        lotSize: "",
        yearBuild: "1987",
        pics: ["MLS_01.jpg", "MLS_08.jpg", "MLS_14.jpg", "MLS_15.jpg", "MLS_19.jpg", "MLS_22.jpg"],
      },
      {
        id: "8617EBroadway",
        sold: true,
        title: "8617 E Broadway., San Gabriel, CA 91776",
        price: "998000",
        soldDate: "2018-01-22",
        soldPrice: "980000",
        bedroom: "5",
        bathroom: "4.5",
        livingArea: "2838",
        lotSize: "6889",
        yearBuild: "2006",
        pics: ["MLS_02.jpg", "MLS_08.jpg", "MLS_12.jpg", "MLS_19.jpg", "MLS_36.jpg", "MLS_40.jpg", "MLS_43.jpg"],
      },
      {
        id: "617NAlhambra",
        sold: true,
        title: "617 N Alhambra Ave., #G, Monterey Park CA 91755",
        price: "545000",
        soldDate: "2018-08-16",
        soldPrice: "",
        bedroom: "3",
        bathroom: "3",
        livingArea: "1177",
        lotSize: "",
        yearBuild: "1973",
        pics: ["00_Complex.jpg", "01_Entrance.jpg", "02_Living_room_1.jpg", "03_Dining_area_1.jpg", "04_Kitchen.jpg", "06_Master_bedroom.jpg", "06a_Master_bathroom.jpg", "07_Bedroom_1.jpg", "08_Patio.jpg"],
      },
      {
        id: "6320CalleElegante",
        sold: true,
        title: "6320 Calle Elegante, Rancho Cucamonga, CA 91737",
        price: "598000",
        soldDate: "2017-12-05",
        soldPrice: "615000",
        bedroom: "4",
        bathroom: "3.5",
        livingArea: "2567",
        lotSize: "9600",
        yearBuild: "1992",
        pics: ["Front_view.jpg", "Living_room.jpg", "Dining_room.jpg", "Kitchen.jpg", "Master_bedroom.jpg", "Master_bathroom.jpg", "Back_yard.jpg", "Back_yard.jpg"],
      },
      {
        id: "1131Hare",
        sold: true,
        title: "1131 Hare Ave., Walnut, CA 91789",
        price: "779000",
        soldDate: "2017-12-05",
        soldPrice: "805000",
        bedroom: "4",
        bathroom: "4",
        livingArea: "2145",
        lotSize: "8178",
        yearBuild: "1965",
        pics: ["MLS_01.jpg", "MLS_12.jpg", "MLS_17.jpg", "MLS_21.jpg", "MLS_36.jpg", "MLS_37.jpg"],
      },
      {
        id: "1015Arcadia",
        sold: true,
        title: "1015 Arcadia Ave.,#19,  Arcadia, CA 91007",
        soldPrice: "589000",
        soldDate: "2017-11-16",
        bedroom: "2",
        bathroom: "2",
        livingArea: "1505",
        lotSize: "",
        yearBuild: "1974",
        pics: ["00_Complex.jpg", "02_Downstaris_bedroom.jpg", "03_Livingroom_2.jpg", "06_Kitchen.jpg", "07_Master_bedroom.jpg", "07a_Master_Bathroom.jpg", "08_Enclosed_patio.jpg", "09_Complex_courtyard.jpg"],
      },
      {
        id: "316NFirst",
        sold: true,
        title: "316 N. First St.,#4, Alhambra, CA 91801",
        soldPrice: "518000",
        bedroom: "3",
        bathroom: "2.5",
        livingArea: "1401",
        yearBuild: "1982",
        pics: ["MLS_03.jpg", "MLS_06.jpg", "MLS_10.jpg", "MLS_12.jpg", "MLS_20.jpg", "MLS_24.jpg"],
      },
      {
        id: "100Electric",
        sold: true,
        title: "100 Electric Ave, #17  Alhambra, CA 91801",
        soldPrice: "515000",
        soldDate: "2017-10-27",
        bedroom: "2",
        bathroom: "2.5",
        livingArea: "1264",
        lotSize: "",
        yearBuild: "1982",
        pics: ["00_Front.jpg", "01_Livingroom_Dining_room.jpg", "03_Kitchen_2.jpg", "05_Master_bedroom.jpg", "05a_Master_bathroom.jpg", "08_Building.jpg", "08_Pool.jpg"],
      },
      {
        id: "428NChapel",
        sold: true,
        title: "428 N Chapel Ave., #D, Alhambra 91801",
        soldPrice: "455000",
        soldDate: "2017-07-26",
        bedroom: "2",
        bathroom: "2",
        livingArea: "995",
        yearBuild: "1991",
        pics: ["00_Exterior_1.jpg", "02_Livingroom_Dining_Area.jpg", "04_Kitchen.jpg", "05_Bathroom_Downstairs.jpg", "06_Bedroom_1.jpg"],
      },
      {
        id: "885SOrangeGrove",
        sold: true,
        title: "885 S Orange Grove Bl # 6, Pasadena 91105",
        soldPrice: "1189000",
        soldDate: "2017-08-18",
        bedroom: "3",
        bathroom: "2.5",
        livingArea: "2455",
        yearBuild: "1973",
        pics: ["Full_01.jpg", "Full_03.jpg", "Full_06.jpg", "Full_11.jpg", "Full_21.jpg", "Full_26.jpg", "Full_30.jpg", "Full_37.jpg"],
      },
      {
        id: "811Rollinst",
        sold: true,
        title: "811 Rollin St, South Pasadena, CA 91030",
        soldPrice: "1370000",
        soldDate: "2017-06-28",
        bedroom: "4",
        bathroom: "3",
        livingArea: "3174",
        lotSize: "13724",
        yearBuild: "1990",
        url: "http://www.811rollinst.com",
        pics: ["Rollinst1.jpg"],
      },
      {
        id: "105EBeaconA",
        sold: true,
        title: "105 E Beacon St # A, Alhambra 91801",
        soldDate: "2017-05-26",
        soldPrice: "541000",
        bedroom: "3",
        bathroom: "2.5",
        livingArea: "1146",
        yearBuild: "1989",
        pics: ["Full_02.jpg", "Full_10.jpg", "Full_16.jpg", "Full_26.jpg", "Full_27.jpg"],
      },
      {
        id: "1701Cedar",
        sold: true,
        title: "1701 Cedar St # 2, Alhambra 91801 ",
        soldPrice: "520000",
        soldDate: "2017-05-19",
        bedroom: "3",
        bathroom: "2.5",
        livingArea: "1350",
        yearBuild: "1984",
        pics: ["Full_02.jpg", "Full_08.jpg", "Full_16.jpg", "Full_27.jpg", "30.jpg"],
      },
      {
        id: "411SGarfield",
        sold: true,
        title: "411 S Garfield Ave., #42, Monterey Park, CA 91754",
        soldDate: "2017-05-18",
        soldPrice: "310000",
        bedroom: "1",
        bathroom: "1",
        livingArea: "721",
        lotSize: "",
        yearBuild: "2007",
        youtube: "https://www.youtube.com/watch?v=pFqNjFLqcmI",
        youtube_zh: "https://www.youtube.com/watch?v=pFqNjFLqcmI",
        youtubePic: "youtube.jpg",
        pics: ["00_Complex Exterior_1.jpg", "01_Livingroom_2.jpg", "03_Kitchen.jpg", "04_Bedroom_3.jpg", "06_Recreation room.jpg", "06_Recreation room_2.jpg", "07_Complex.jpg", "07_Complex_2.jpg", "08_Driveway.jpg"],
      },

      {
        id: "89Commonwealth",
        sold: true,
        title: "89 Commonwealth Ave., #3c, Alhambra CA 91801",
        soldDate: "2017-03-30",
        soldPrice: "428000",
        bedroom: "1",
        bathroom: "1",
        livingArea: "990",
        lotSize: "",
        yearBuild: "2006",
        youtube: "https://www.youtube.com/watch?v=k0KGqt7FAtw&t=5s",
        youtube_zh: "https://www.youtube.com/watch?v=knkm7-kR330",
        youtubePic: "Full_01_V.jpg",
        pics: ["Full_01.jpg", "Full_28.jpg", "Full_07.jpg", "Full_10.jpg", "Full_18.jpg", "Full_23.jpg"],
      },
      {
        id: "617EAngeleno",
        sold: true,
        title: "617 E Angeleno Av # 303, Burbank 91501",
        price: "",
        soldDate: "2017-04-11",
        soldPrice: "440000",
        bedroom: "2",
        bathroom: "2",
        livingArea: "1138",
        yearBuild: "1969",
        pics: ["Full_02.jpg", "Full_09.jpg", "Full_14.jpg", "Full_21.jpg", "Full_22.jpg", "Full_28.jpg"],
      },
      {
        id: "786Banyan",
        sold: true,
        title: "786 Banyan Way, Pomona, CA 91767",
        price: "",
        soldDate: "2017-03-08",
        soldPrice: "480000",
        bedroom: "3",
        bathroom: "3",
        livingArea: "1850",
        lotSize: "",
        yearBuild: "2017",
        pics: ["00_Front.JPG", "01_Downstairs_Loft.JPG", "01_Downstairs_Loft_1.JPG", "02_Living_room_Dining_room.JPG", "02_Living_room_Dining_room.JPG", "03_Kitchen.JPG", "04_Master_bedroom.JPG", "05_Master_bathroom.JPG", "05_Master_bathroom_1.JPG", "05_Master_bedroom_Walk-in_closet.JPG", "06_Bedroom.JPG", "06a_Hallway_bathroom.JPG", "07_Patio.JPG", "08_BBQ_area.JPG", "08_Playground.JPG"],
      },
      {
        id: "1312Elm",
        sold: true,
        title: "1312 Elm St, Alhambra, CA 91083",
        soldDate: "2017-02-10",
        soldPrice: "584000",
        bedroom: "2",
        bathroom: "1",
        livingArea: "1034",
        lotSize: "6616",
        yearBuild: "1942",
        pics: ["MLS_02.jpg", "MLS_07.jpg", "MLS_16.jpg", "MLS_25.jpg", "MLS_29.jpg", "MLS_42.jpg"],
      },
      {
        id: "2431south3rd",
        sold: true,
        title: "2431 S 3rd Ave, Arcadia, CA 91006",
        soldDate: "2016-11-01",
        soldPrice: "2700000",
        bedroom: "5",
        bathroom: "6",
        livingArea: "6782",
        lotSize: "15386",
        yearBuild: "2009",
        pics: ["Front.jpg", "Livingroom.jpg", "Office.jpg", "Kitchen.jpg", "Master_bedroom.jpg", "Master_bathroom.jpg", "Back_yard.jpg"],
      },
      {
        id: "545LaPaz",
        sold: true,
        title: "545 La Paz Dr, San Marno, CA 91108",
        soldDate: "2016-06-27",
        soldPrice: "1995000",
        bedroom: "3",
        bathroom: "2",
        livingArea: "2732",
        yearBuild: "1927",
        pics: ["LaPaz1.jpg", "LaPaz2.jpg", "LaPaz3.jpg", "LaPaz4.jpg", "LaPaz5.jpg", "LaPaz6.jpg"],
      },
      {
        id: "725Plymouth",
        sold: true,
        title: "725 Plymouth Rd, San Marino, CA 91108",
        soldDate: "2016-07-13",
        soldPrice: "2380000",
        bedroom: "4",
        bathroom: "3",
        livingArea: "2943",
        yearBuild: "1928",
        pics: ["Plymouth6.jpg", "Plymouth2.jpg", "Plymouth3.jpg", "Plymouth4.jpg", "Plymouth5.jpg", "Plymouth1.jpg"],
      },
      {
        id: "1145RosalindSanMarino",
        sold: true,
        title: "1145 Rosalind Rd, San Marino, CA 91108",
        soldDate: "2015-08-28",
        soldPrice: "5300000",
        bedroom: "6",
        bathroom: "7",
        livingArea: "4605",
        lotSize: "37900",
        yearBuild: "1953",
        pics: ["Rosalind0.jpg", "Rosalind1.jpg", "Rosalind2.jpg", "Rosalind8.jpg", "Rosalind4.jpg", "Rosalind5.jpg"],
      },
      {
        id: "8WNorman",
        sold: true,
        title: "8 W. Norman Ave, Arcadia CA 91006",
        soldDate: "2015-06-16",
        soldPrice: "2700000",
        bedroom: "5",
        bathroom: "6",
        livingArea: "5616",
        lotSize: "13476",
        yearBuild: "2014",
        pics: ["1_8WNorman.jpg", "2_8WNorman.jpg", "3_8WNorman.jpg", "4_8WNorman.jpg", "5_8WNorman.jpg", "6_8WNorman.jpg", "7_8WNorman.jpg"],
      },
      {
        id: "3010ESunsetHill",
        sold: true,
        title: "3010 E Sunset Hill Dr, West Covina, CA 91791",
        price: "918000",
        soldDate: "2016-09-27",
        soldPrice: "850000",
        bedroom: "4",
        bathroom: "4",
        livingArea: "3157",
        lotSize: "17480",
        yearBuild: "1984",
        pics: ["sunsethill1.jpg", "Housefront.jpg", "Livingroom.jpg", "Kitchen.jpg", "Masterbathroom.jpg", "Masterbedroom.jpg", "BackPatio.jpg", "BackYard.jpg"],
      },
      {
        id: "2150FultonAve",
        sold: true,
        title: "2150 Fulton Ave, Monterey Park, CA 91755",
        price: "",
        soldDate: "2016-09-30",
        soldPrice: "580000",
        bedroom: "3",
        bathroom: "1",
        livingArea: "1056",
        lotSize: "12122",
        yearBuild: "1949",
        pics: ["2150FultonAve1.jpg", "2150FultonAve2.jpg", "2150FultonAve3.jpg", "2150FultonAve4.jpg", "2150FultonAve5.jpg", "2150FultonAve6.jpg"],
      },
      {
        id: "39Fano",
        sold: true,
        title: "39 Fano St., #C, Arcadia, CA 91007",
        soldDate: "2016-02-03",
        soldPrice: "750000",
        bedroom: "3",
        bathroom: "3",
        livingArea: "1890",
        lotSize: "",
        yearBuild: "2002",
        pics: ["39Fano1.jpg", "39Fano2.jpg", "39Fano3.jpg", "39Fano4.jpg", "39Fano5.jpg"],
      },
      {
        id: "521Arbolada",
        sold: true,
        title: "521 Arbolada Dr, Arcadia, CA 91006",
        soldDate: "2015-04-23",
        soldPrice: "2450000",
        bedroom: "4",
        bathroom: "4",
        livingArea: "3282",
        lotSize: "20941",
        yearBuild: "1951",
        pics: ["Arbolada1.jpg", "Arbolada2.jpg", "Arbolada3.jpg", "Arbolada4.jpg", "Arbolada5.jpg", "Arbolada6.jpg", "Arbolada7.jpg"],
      },
      {
        id: "5762Ridgeview",
        sold: true,
        title: "5762 Ridgeview Dr, La Verne Ca 91750",
        soldDate: "2015-08-06",
        soldPrice: "982000",
        bedroom: "4",
        bathroom: "3",
        livingArea: "3160",
        lotSize: "9019",
        yearBuild: "1997",
        pics: ["Ridgeview1.jpg", "Ridgeview2.jpg", "Ridgeview3.jpg", "Ridgeview4.jpg", "Ridgeview5.jpg", "Ridgeview6.jpg"],
      },
      {
        id: "451Woodruff",
        sold: true,
        title: "451 W Woodruff Ave., Arcadia, CA 91007",
        soldDate: "2015-08-31",
        soldPrice: "2378000",
        bedroom: "6",
        bathroom: "5",
        livingArea: "5352",
        lotSize: "12831",
        yearBuild: "1997",
        pics: ["451Woodruff1.jpg", "451Woodruff2.jpg", "451Woodruff3.jpg", "451Woodruff4.jpg", "451Woodruff5.jpg"],
      },
      {
        id: "310W",
        sold: true,
        title: "310 W Wooward Ave., # B, Alhambra, CA 91801",
        price: "548000",
        soldDate: "2018-08-29",
        soldPrice: "",
        bedroom: "3",
        bathroom: "3",
        livingArea: "1911",
        lotSize: "",
        yearBuild: "1987",
        pics: ["MLS_02.jpg", "MLS_08.jpg", "MLS_13.jpg", "MLS_16.jpg", "MLS_27.jpg", "MLS_29.jpg"],
      },
      {
        id: "228Monterey",
        sold: true,
        title: "228 Monterey Rd., #F, South Pasadena, CA 91030",
        soldDate: "2015-12-18",
        soldPrice: "515000",
        bedroom: "2",
        bathroom: "3",
        livingArea: "1121",
        lotSize: "",
        yearBuild: "1985",
        pics: ["228Monterey1.jpg", "228Monterey2.jpg", "228Monterey3.jpg", "228Monterey4.jpg", "228Monterey5.jpg"],
      },
      {
        id: "856SMarengo",
        sold: true,
        title: "856 S Marengo Ave, #3, Pasadena CA91106",
        soldDate: "2015-01-04",
        soldPrice: "680500",
        bedroom: "3",
        bathroom: "3",
        livingArea: "1413",
        lotSize: "",
        yearBuild: "1998",
        pics: ["856SMarengo1.jpg", "856SMarengo2.jpg", "856SMarengo3.jpg", "856SMarengo4.jpg", "856SMarengo5.jpg", "856SMarengo6.jpg"],
      },
      {
        id: "392SMarengo",
        sold: true,
        title: "392 S. Marengo Ave., #108, CA 91101",
        soldDate: "2015-03-26",
        soldPrice: "697500",
        bedroom: "4",
        bathroom: "3",
        livingArea: "1924",
        lotSize: "",
        yearBuild: "1993",
        pics: ["392SMarengo1.jpg", "392SMarengo2.jpg", "392SMarengo3.jpg", "392SMarengo4.jpg", "392SMarengo5.jpg"],
      },
      {
        id: "375Grand",
        sold: true,
        title: "375 Grand Ave, Monrovia, CA 91016",
        soldDate: "2015-02-24",
        soldPrice: "860000",
        bedroom: "3",
        bathroom: "3",
        livingArea: "1632",
        lotSize: "7486",
        yearBuild: "1957",
        pics: ["375Grand1.jpg", "375Grand2.jpg", "375Grand3.jpg", "375Grand4.jpg", "375Grand5.jpg", "375Grand6.jpg"],
      },
      {
        id: "1130Arcadia",
        sold: true,
        title: "1130 Arcadia Ave., #C, Arcadia CA 91007",
        soldDate: "2015-03-26",
        soldPrice: "538000",
        bedroom: "2",
        bathroom: "2",
        livingArea: "1390",
        lotSize: "",
        yearBuild: "1971",
        pics: ["1130Arcadia1.jpg", "1130Arcadia2.jpg", "1130Arcadia3.jpg", "1130Arcadia4.jpg", "1130Arcadia5.jpg"],
      },
      // {
      //   id: '620TheVillage',
      //   sold: true,
      //   title: '620 The Village, #312, Redondo Beach, CA 90277',
      //   soldDate: '2015-03-27',
      //   soldPrice: '540000',
      //   bedroom: '1',
      //   bathroom: '1',
      //   livingArea: '619',
      //   lotSize: '',
      //   yearBuild: '1974',
      //   pics: ['620TheVillage1.jpg','620TheVillage2.jpg','620TheVillage3.jpg','620TheVillage4.jpg','620TheVillage5.jpg']
      // },
      {
        id: "366CaminoDelSol",
        sold: true,
        title: "366 Camino Del Sol, South Pasadena CA 91030",
        soldDate: "2015-01-30",
        soldPrice: "1586000",
        bedroom: "4",
        bathroom: "4",
        livingArea: "3613",
        lotSize: "7962",
        yearBuild: "1965",
        pics: ["1_366CaminoDelSol.jpg", "2_366CaminoDelSol.jpg", "3_366CaminoDelSol.jpg", "4_366CaminoDelSol.jpg", "5_366CaminoDelSol.jpg", "6_366CaminoDelSol.jpg"],
      },
      {
        id: "10015ViaPescadero",
        sold: true,
        title: "10015 Via Pescadero, Moreno Valley, CA 92557",
        soldDate: "2016-08-24",
        soldPrice: "399000",
        bedroom: "5",
        bathroom: "3",
        livingArea: "2917",
        lotSize: "",
        yearBuild: "2004",
        pics: ["Pescadero0.jpg", "Pescadero1.jpg", "Pescadero2.jpg", "Pescadero3.jpg", "Pescadero4.jpg"],
      },
      {
        id: "2849Weidermeyer",
        sold: true,
        title: "2849 Weidermeyer Ave. Arcadia CA 91006",
        soldDate: "2016-08-23",
        soldPrice: "510000",
        bedroom: "3",
        bathroom: "1",
        livingArea: "1042",
        lotSize: "",
        yearBuild: "1949",
        pics: ["Weidermeyer0.jpg", "Weidermeyer1.jpg", "Weidermeyer2.jpg", "Weidermeyer3.jpg", "Weidermeyer4.jpg", "Weidermeyer5.jpg"],
      },
      {
        id: "1020marengo",
        sold: true,
        title: "1020 S Marengo Ave #8, Alhambra, CA 91803",
        soldDate: "2016-08-16",
        soldPrice: "388000",
        price: "388000",
        bedroom: "3",
        bathroom: "2.5",
        livingArea: "1220",
        lotSize: "",
        yearBuild: "1984",
        url: "http://www.1020marengo.com/",
        pics: ["marengo1.jpg", "marengo2.jpg", "marengo3.jpg", "marengo4.jpg", "marengo5.jpg", "marengo6.jpg"],
      },

      {
        id: "1822WGarveyAveAlhambra",
        sold: true,
        title: "1822 W. Garvey Ave., Alhambra, CA 91803",
        soldDate: "2016-07-22",
        soldPrice: "455000",
        bedroom: "2",
        bathroom: "3",
        livingArea: "1409",
        yearBuild: "1980",
        pics: ["1822WGarvey1.jpg", "1822WGarvey2.jpg", "1822WGarvey3.jpg", "1822WGarvey4.jpg", "1822WGarvey5.jpg", "1822WGarvey6.jpg"],
      },
      {
        id: "Walnut525Southcoast",
        sold: true,
        title: "525 Southcoast Dr, Walnut, CA 91789",
        price: "698000",
        soldDate: "2016-07-28",
        soldPrice: "670000",
        bedroom: "4",
        bathroom: "2",
        livingArea: "2276",
        lotSize: "8648",
        yearBuild: "1975",
        pics: ["Walnut525Southcoast1.jpg", "Walnut525Southcoast2.jpg", "Walnut525Southcoast3.jpg", "Walnut525Southcoast4.jpg", "Walnut525Southcoast5.jpg"],
      },
      {
        id: "1908CedarAlhambra",
        sold: true,
        title: "1908 Cedar St, Alhambra, CA 91801",
        price: "398000",
        soldDate: "2016-06-30",
        soldPrice: "415000",
        bedroom: "2",
        bathroom: "2",
        livingArea: "905",
        lotSize: "",
        yearBuild: "1994",
        pics: ["Cedar1.jpg", "Cedar4.jpg", "Cedar6.jpg", "Cedar8.jpg", "Cedar7.jpg", "Cedar9.jpg"],
      },
      {
        id: "Arcadia804caminoreal",
        sold: true,
        title: "804 W Camino Real Ave, Arcadia, CA 91007",
        soldDate: "2016-05-11",
        soldPrice: "625000",
        price: "658000",
        bedroom: "2",
        bathroom: "1",
        livingArea: "782",
        lotSize: "5658",
        yearBuild: "",
        url: "http://www.804caminoreal.com/",
        pics: ["caminoreal1.jpg", "caminoreal2.jpg", "caminoreal3.jpg", "caminoreal4.jpg", "caminoreal5.jpg", "caminoreal6.jpg"],
      },
      {
        id: "Alhambra2721WShorb",
        sold: true,
        title: "2721 W. Shorb Street, Alhambra",
        soldPrice: "495000",
        bedroom: "2",
        bathroom: "2",
        livingArea: "996",
        lotSize: "4589",
        yearBuild: "",
        url: "http://www.2721shorb.com/",
        pics: ["WShorb1.jpg", "WShorb2.jpg", "WShorb3.jpg", "WShorb4.jpg", "WShorb5.jpg", "WShorb6.jpg", "WShorb7.jpg"],
      },
      {
        id: "1820garvey",
        sold: true,
        title: "1820 Garvey Ave #3, Alhambra CA 91803",
        soldDate: "2016-04-12",
        soldPrice: "448000",
        bedroom: "3",
        bathroom: "2.5",
        livingArea: "1498",
        lotSize: "",
        yearBuild: "1980",
        url: "http://www.1820garvey.com/",
        pics: ["01_Livingroom.jpg", "02_Dining.jpg", "03_Master-bedroom.jpg", "04_Bedroom.jpg", "05_Bonus-Room-garage.jpg", "00_Community.jpg"],
      },
      {
        id: "116chapel",
        sold: true,
        title: "116 S Chapel Ave, Alhambra, CA 91801",
        soldDate: "2016-04-13",
        soldPrice: "456000",
        bedroom: "2",
        bathroom: "2.5",
        livingArea: "1313",
        url: "http://www.116chapel.com/",
        pics: ["1_116chapel.jpg", "2_116chapel.jpg", "3_116chapel.jpg", "4_116chapel.jpg", "6_116chapel.jpg", "5_116chapel.jpg"],
      },
      {
        id: "71bonnieave",
        sold: true,
        title: "71 N Bonnie Ave #1, Pasadena, CA",
        soldDate: "2016-04-26",
        soldPrice: "780000",
        listingPrice: "795000",
        bedroom: "3",
        bathroom: "2.5",
        livingArea: "1637",
        lotSize: "8030",
        yearBuild: "2012",
        url: "http://www.71bonnieave.com/",
        pics: ["1_71bonnieave.jpg", "2_71bonnieave.jpg", "3_71bonnieave.jpg", "4_71bonnieave.jpg", "5_71bonnieave.jpg", "6_71bonnieave.jpg"],
      },
      {
        id: "885orangegrove",
        sold: true,
        title: "885 S. Orange Grove Blvd., #6, Pasadena, CA 91105",
        soldDate: "2016-10-02",
        soldPrice: "924000",
        bedroom: "3",
        bathroom: "3",
        livingArea: "2544",
        lotSize: "",
        yearBuild: "1973",
        pics: ["orangegrove0.jpg", "orangegrove1.jpg", "orangegrove2.jpg", "orangegrove3.jpg", "orangegrove4.jpg", "orangegrove5.jpg"],
      },
      {
        id: "Covina758ELevel",
        sold: true,
        title: "758 E. Level St, Covina, CA 91723",
        soldDate: "2016-04-01",
        soldPrice: "498000",
        bedroom: "3",
        bathroom: "2",
        livingArea: "1537",
        lotSize: "8334",
        yearBuild: "1960",
        pics: ["Convina1.jpg", "Convina2.jpg", "Convina3.jpg", "Convina4.jpg", "Convina5.jpg", "Convina6.jpg"],
      },
      {
        id: "Arcadia325California",
        sold: true,
        title: "325 California St. #B. Arcadia, CA 91006",
        soldDate: "2016-2-29",
        soldPrice: "895000",
        bedroom: "4",
        bathroom: "3",
        livingArea: "2187",
        lotSize: "",
        yearBuild: "2000",
        pics: ["California1.jpg", "California2.jpg", "California3.jpg", "California4.jpg", "California5.jpg"],
      },
      {
        id: "831stoneman",
        sold: true,
        title: "831 South Stoneman Ave.,# A, Alhambra CA 91801",
        soldDate: "2016-02-16",
        soldPrice: "518000",
        bedroom: "3",
        bathroom: "3",
        livingArea: "1660",
        lotSize: "",
        yearBuild: "1991",
        pics: ["stoneman0.jpg", "stoneman1.jpg", "stoneman2.jpg", "stoneman3.jpg", "stoneman4.jpg"],
      },
      {
        id: "3542WillowGlen",
        sold: true,
        title: "3542 Willow Glen Ln, West Covina, CA 91792",
        soldDate: "2016-01-29",
        soldPrice: "660000",
        bedroom: "4",
        bathroom: "3",
        livingArea: "2215",
        lotSize: "4051",
        yearBuild: "2005",
        pics: ["WillowGlen1.jpg", "WillowGlen2.jpg", "WillowGlen3.jpg", "WillowGlen4.jpg", "WillowGlen5.jpg", "WillowGlen6.jpg"],
      },
      {
        id: "13949DoveCanyon",
        sold: true,
        title: "13949 Dove Canyon Way, Rancho Cucamonga, CA 91739",
        soldDate: "2016-01-29",
        soldPrice: "515000",
        bedroom: "4",
        bathroom: "3",
        livingArea: "2378",
        lotSize: "6025",
        yearBuild: "2006",
        pics: ["DoveCanyon0.jpg", "DoveCanyon1.jpg", "DoveCanyon2.jpg", "DoveCanyon3.jpg", "DoveCanyon4.jpg", "DoveCanyon5.jpg"],
      },
      {
        id: "4625Michigan",
        sold: true,
        title: "4625 Michigan Ave, Los Angeles, CA 90022",
        soldDate: "2016-07-26",
        soldPrice: "510000",
        bedroom: "2",
        bathroom: "1",
        livingArea: "1795",
        lotSize: "",
        yearBuild: "1961",
        pics: ["Michigan1.jpg", "Michigan2.jpg", "Michigan3.jpg", "Michigan4.jpg", "Michigan5.jpg"],
      },
      {
        id: "1103alhambra",
        sold: true,
        title: "1103 Alhambra, San Gabriel, CA 91775",
        soldDate: "2015-11-24",
        soldPrice: "792000",
        bedroom: "3",
        bathroom: "3",
        livingArea: "2765",
        lotSize: "6280",
        yearBuild: "1940",
        pics: ["1103Alhambra1.jpg", "1103Alhambra2.jpg", "1103Alhambra3.jpg", "1103Alhambra4.jpg", "1103Alhambra5.jpg", "1103Alhambra6.jpg"],
      },
      {
        id: "Monterey1052SGarfield",
        sold: true,
        title: "1052 S. Garfield Ave, Monterey Park, CA 91754",
        soldDate: "2015-11-20",
        soldPrice: "440000",
        bedroom: "3",
        bathroom: "3",
        livingArea: "1536",
        lotSize: "1131",
        yearBuild: "1981",
        pics: ["Garfield1.jpg", "Garfield2.jpg", "Garfield3.jpg", "Garfield4.jpg", "Garfield5.jpg"],
      },
      {
        id: "Alhambra1715Westmont",
        sold: true,
        title: "1715 Westmont Drive, Alhambra CA 91803",
        soldDate: "2015-11-10",
        soldPrice: "570000",
        bedroom: "3",
        bathroom: "2",
        livingArea: "1283",
        lotSize: "4800",
        yearBuild: "1954",
        pics: ["Westmont1.jpg", "Westmont2.jpg", "Westmont3.jpg", "Westmont4.jpg", "Westmont5.jpg"],
      },
      {
        id: "1915Sycamore",
        sold: true,
        title: "1915 Sycamore Dr, San Marino, CA 91108",
        soldDate: "2015-10-27",
        soldPrice: "1450000",
        bedroom: "3",
        bathroom: "2",
        livingArea: "2255",
        lotSize: "8698",
        yearBuild: "1940",
        pics: ["1_1915Sycamore.jpg", "2_1915Sycamore.jpg", "3_1915Sycamore.jpg", "4_1915Sycamore.jpg", "5_1915Sycamore.jpg"],
      },
      {
        id: "1652LaGolondrianAve",
        sold: true,
        title: "1652 La Golondrian Ave, Alhambra CA 91803",
        soldDate: "2015-10-07",
        soldPrice: "610000",
        bedroom: "2",
        bathroom: "2",
        livingArea: "1584",
        lotSize: "4787",
        yearBuild: "1930",
        pics: ["1_1652LaGolondrianAve.jpg", "2_1652LaGolondrianAve.jpg", "3_1652LaGolondrianAve.jpg", "4_1652LaGolondrianAve.jpg", "5_1652LaGolondrianAve.jpg"],
      },
      {
        id: "15407Memphis",
        sold: true,
        title: "15407 Memphis Dr, Fontana, CA 92336",
        soldDate: "2015-11-05",
        soldPrice: "395000",
        bedroom: "4",
        bathroom: "3",
        livingArea: "2440",
        lotSize: "5000",
        yearBuild: "2002",
        pics: ["1_15407Memphis.jpg", "2_15407Memphis.jpg", "3_15407Memphis.jpg", "4_15407Memphis.jpg", "5_15407Memphis.jpg"],
      },
      {
        id: "126WLeRoyAve",
        sold: true,
        title: "126 W LeRoy Ave, Arcadia, CA 91007",
        soldDate: "2015-11-03",
        soldPrice: "975000",
        bedroom: "3",
        bathroom: "2",
        livingArea: "1756",
        lotSize: "7371",
        yearBuild: "1946",
        pics: ["1_126WLeRoyAve.jpg", "2_126WLeRoyAve.jpg", "3_126WLeRoyAve.jpg", "4_126WLeRoyAve.jpg", "5_126WLeRoyAve.jpg"],
      },
      {
        id: "935Ackley",
        sold: true,
        title: "935 Ackley St, Monterey Park, CA 91755",
        soldDate: "2015-07-17",
        soldPrice: "555000",
        bedroom: "3",
        bathroom: "2",
        livingArea: "1332",
        lotSize: "6272",
        yearBuild: "1961",
        pics: ["1_935Ackley.jpg", "2_935Ackley.jpg", "3_935Ackley.jpg", "4_935Ackley.jpg", "5_935Ackley.jpg"],
      },
      {
        id: "513WCommonwealth",
        sold: true,
        title: "513 W. Commonwealth Ave., Alhambra, CA 91801",
        soldDate: "2015-07-28",
        soldPrice: "443000",
        bedroom: "2",
        bathroom: "1",
        livingArea: "898",
        lotSize: "2446",
        yearBuild: "1954",
        pics: ["1_513WCommonwealth.jpg", "2_513WCommonwealth.jpg", "3_513WCommonwealth.jpg", "4_513WCommonwealth.jpg", "5_513WCommonwealth.jpg"],
      },
      {
        id: "105EBeacon",
        sold: true,
        title: "105  E Beacon St., #B. Alhambra, CA 91801",
        soldDate: "2015-07-07",
        soldPrice: "443000",
        bedroom: "3",
        bathroom: "2",
        livingArea: "1350",
        lotSize: "",
        yearBuild: "1989",
        pics: ["1_105EBeacon.jpg", "2_105EBeacon.jpg", "3_105EBeacon.jpg", "4_105EBeacon.jpg", "5_105EBeacon.jpg"],
      },
      {
        id: "2104Westmont",
        sold: true,
        title: "2104 Westmont Dr., Alhambra, CA 91803",
        soldDate: "2015-07-24",
        soldPrice: "700000",
        bedroom: "4",
        bathroom: "4",
        livingArea: "1902",
        lotSize: "6674",
        yearBuild: "1953",
        pics: ["1_2104Westmont.jpg", "2_2104Westmont.jpg", "3_2104Westmont.jpg", "4_2104Westmont.jpg", "5_2104Westmont.jpg", "6_2104Westmont.jpg"],
      },
      {
        id: "1002RoyalOaks",
        sold: true,
        title: "1002 Royal Oaks Dr., #B. Monrovia, CA 91016",
        soldDate: "2015-07-29",
        soldPrice: "530000",
        bedroom: "2",
        bathroom: "3",
        livingArea: "1901",
        lotSize: "",
        yearBuild: "1993",
        pics: ["1_1002RoyalOaks.jpg", "2_1002RoyalOaks.jpg", "3_1002RoyalOaks.jpg", "4_1002RoyalOaks.jpg", "5_1002RoyalOaks.jpg", "6_1002RoyalOaks.jpg"],
      },
      {
        id: "308NMarguerita",
        sold: true,
        title: "308 N. Marguerita Ave., #E, Alhambra, CA 91801",
        soldDate: "2015-08-11",
        soldPrice: "462000",
        bedroom: "3",
        bathroom: "3",
        livingArea: "1245",
        lotSize: "",
        yearBuild: "1989",
        pics: ["1_308NMarguerita.jpg", "2_308NMarguerita.jpg", "3_308NMarguerita.jpg", "4_308NMarguerita.jpg", "5_308NMarguerita.jpg"],
      },
      {
        id: "15SValencia",
        sold: true,
        title: "15 S. Valencia St. Alhambra, CA 91801",
        soldDate: "2015-09-10",
        soldPrice: "638000",
        bedroom: "3",
        bathroom: "2",
        livingArea: "1648",
        lotSize: "8400",
        yearBuild: "1929",
        pics: ["1_15SValencia.jpg"],
      },
      {
        id: "1070HastingsRanch",
        sold: true,
        title: "1070 Hastings Ranch Dr, Pasadena, CA 91107",
        soldDate: "2015-06-04",
        soldPrice: "848000",
        bedroom: "3",
        bathroom: "3",
        livingArea: "1663",
        lotSize: "9438",
        yearBuild: "1951",
        pics: ["1_1070HastingsRanch.jpg", "2_1070HastingsRanch.jpg", "3_1070HastingsRanch.jpg", "4_1070HastingsRanch.jpg", "5_1070HastingsRanch.jpg", "6_1070HastingsRanch.jpg"],
      },
      {
        id: "12256Kneeland",
        sold: true,
        title: "12256 Kneeland Dr, Rancho Cucamonga, CA 91739",
        soldDate: "2015-03-25",
        soldPrice: "675000",
        bedroom: "5",
        bathroom: "3",
        livingArea: "3156",
        lotSize: "10424",
        yearBuild: "2004",
        pics: ["1_12256Kneeland.jpg", "2_12256Kneeland.jpg", "3_12256Kneeland.jpg", "4_12256Kneeland.jpg", "5_12256Kneeland.jpg"],
      },
      {
        id: "503NAtlantic",
        sold: true,
        title: "503 N Atlantic Blvd., #B, Alhambra CA 91801",
        soldDate: "2015-03-12",
        soldPrice: "400000",
        bedroom: "2",
        bathroom: "3",
        livingArea: "1016",
        lotSize: "",
        yearBuild: "2000",
        pics: ["1_503NAtlantic.jpg", "2_503NAtlantic.jpg", "3_503NAtlantic.jpg", "4_503NAtlantic.jpg", "5_503NAtlantic.jpg"],
      },
      {
        id: "1712Vine",
        sold: true,
        title: "1712 Vine St.,#B,  Alhambra, CA 91801",
        soldDate: "2015-03-10",
        soldPrice: "445000",
        bedroom: "3",
        bathroom: "2",
        livingArea: "1391",
        lotSize: "",
        yearBuild: "1995",
        pics: ["1_1712Vine.jpg", "2_1712Vine.jpg", "3_1712Vine.jpg", "4_1712Vine.jpg", "5_1712Vine.jpg"],
      },

      //{id: '', sold:false, title:'', price:'',soldDate:'' soldPrice:'', bedroom:'', bathroom:'', livingArea:'', lotSize:'', yearBuild:'', pics:[]}
    ],
  },
};

export default listingStore;
